// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import {
//     ChevronDown, ChevronUp, Plus, Edit, Trash2,
//     Home, ShoppingBag, UserCircle, Settings, LogOut,
//     Calendar, X, Camera, Save, Upload
// } from 'lucide-react';
// import logo from '../images/logo.png';
// import Navigation from './mealListNavigation';
// import PersonalInfoCard from '../components/personalifo_card';
// import AddressList from '../components/AddressList';
// import MapPicker from '../components/MapPicker';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// // Extension Modal Component
// const ExtensionModal = ({ isOpen, onClose, orderID, onExtensionConfirm }) => {
//     const [extensionDetails, setExtensionDetails] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [selectedDate, setSelectedDate] = useState(null);
//     const [currentDate, setCurrentDate] = useState(new Date());
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         if (isOpen && orderID) {
//             fetchExtensionDetails();
//         }
//     }, [isOpen, orderID]);

//     const fetchExtensionDetails = async () => {
//         try {
//             setLoading(true);
//             setError(null);
//             const response = await axios.post('https://api.dailyfit.ae/api/user/get-extension-details', {
//                 orderID: orderID
//             }, { withCredentials: true });

//             setExtensionDetails(response.data.data);
//             setSelectedDate(null);
//         } catch (err) {
//             console.error('Error fetching extension details', err);
//             setError('Failed to load extension details. Please try again.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const getDaysInMonth = (date) => {
//         const year = date.getFullYear();
//         const month = date.getMonth();
//         const firstDay = new Date(year, month, 1);
//         const lastDay = new Date(year, month + 1, 0);
//         const daysInMonth = lastDay.getDate();
//         const startingDayOfWeek = firstDay.getDay();

//         const days = [];

//         for (let i = 0; i < startingDayOfWeek; i++) {
//             days.push(null);
//         }

//         for (let day = 1; day <= daysInMonth; day++) {
//             days.push(new Date(year, month, day));
//         }

//         return days;
//     };

//     const handleDateClick = (date) => {
//         if (!date || !extensionDetails) return;

//         const dateString = date.toISOString();
//         const extendableUpto = new Date(extensionDetails.extendableUpto);
//         extendableUpto.setHours(23, 59, 59, 999);

//         if (date > extendableUpto) {
//             setError(`You can only extend up to ${extendableUpto.toLocaleDateString()}`);
//             return;
//         }

//         if (isDateInNonClickableRange(date)) {
//             return;
//         }

//         setSelectedDate(dateString);
//         setError(null);
//     };

//     const isDateSelected = (date) => {
//         if (!date) return false;
//         if (!selectedDate) return false;

//         const dateString = date.toISOString().split('T')[0];
//         const selectedDateString = new Date(selectedDate).toISOString().split('T')[0];
//         return dateString === selectedDateString;
//     };

//     const isDateInNonClickableRange = (date) => {
//         if (!date) return false;

//         const today = new Date();
//         today.setHours(0, 0, 0, 0);

//         const twoDaysFromToday = new Date(today);
//         twoDaysFromToday.setDate(today.getDate() + 2);
//         twoDaysFromToday.setHours(23, 59, 59, 999);

//         const checkDate = new Date(date);
//         checkDate.setHours(0, 0, 0, 0);

//         return checkDate >= today && checkDate <= twoDaysFromToday;
//     };

//     const isDateDisabled = (date) => {
//         if (!date || !extensionDetails) return true;

//         const today = new Date();
//         today.setHours(0, 0, 0, 0);

//         if (date < today) return true;

//         const extendableUpto = new Date(extensionDetails.extendableUpto);
//         extendableUpto.setHours(23, 59, 59, 999);
//         if (date > extendableUpto) return true;

//         if (isDateInNonClickableRange(date)) return true;

//         return false;
//     };

//     const getDateClassName = (date) => {
//         if (!date) return 'invisible';

//         let className = 'h-10 w-10 text-sm rounded-lg transition-colors ';

//         if (isDateDisabled(date)) {
//             if (isDateInNonClickableRange(date)) {
//                 className += 'bg-gray-200 text-gray-500 cursor-not-allowed border-2 border-gray-300';
//             } else {
//                 className += 'text-gray-300 cursor-not-allowed';
//             }
//         } else {
//             className += 'text-gray-700 hover:bg-green-100 cursor-pointer';
//         }

//         if (isDateSelected(date)) {
//             className += ' bg-green-600 text-white hover:bg-green-700';
//         }

//         return className;
//     };

//     const handleConfirmExtension = async () => {
//         if (!selectedDate) {
//             setError('Please select a date for extension');
//             return;
//         }

//         try {
//             const response = await axios.post(
//                 'https://api.dailyfit.ae/api/user/extend-order',
//                 {
//                     orderID: orderID,
//                     extendedDate: selectedDate
//                 },
//                 { withCredentials: true }
//             );

//             if (response.data.status) {
//                 onExtensionConfirm(orderID, [selectedDate]);
//                 onClose();
//             } else {
//                 setError(response.data.message || 'Extension failed. Please try again.');
//             }
//         } catch (err) {
//             console.error('Error confirming extension', err);
//             setError('Failed to confirm extension. Please try again.');
//         }
//     };

//     const navigateMonth = (direction) => {
//         setCurrentDate(prev => {
//             const newDate = new Date(prev);
//             newDate.setMonth(prev.getMonth() + direction);
//             return newDate;
//         });
//     };

//     if (!isOpen) return null;

//     const days = getDaysInMonth(currentDate);
//     const monthYear = currentDate.toLocaleDateString('en-US', {
//         month: 'long',
//         year: 'numeric'
//     });

//     return (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//             <div className="bg-white p-6 rounded-lg w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
//                 <div className="flex justify-between items-center mb-4">
//                     <h2 className="text-xl font-semibold text-green-800">
//                         Extend Your Meal Plan
//                     </h2>
//                     <button
//                         onClick={onClose}
//                         className="text-gray-400 hover:text-gray-600"
//                     >
//                         <X size={24} />
//                     </button>
//                 </div>

//                 {loading ? (
//                     <div className="flex justify-center py-8">
//                         <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-green-600"></div>
//                     </div> 
//                 ) : extensionDetails ? (
//                     <div className="space-y-6">
//                         <div className="bg-green-100 p-4 rounded-lg border border-green-200">
//                             <p className="text-green-800 font-medium">
//                                 You can extend your meal plan by <span className="font-bold">1 day</span>
//                             </p>
//                             <p className="text-sm text-green-700 mt-1">
//                                 Extendable up to: {new Date(extensionDetails.extendableUpto).toLocaleDateString()}
//                             </p>
//                             {extensionDetails.remainingMealDays && (
//                                 <p className="text-sm text-green-700 mt-1">
//                                     Remaining meal days: {extensionDetails.remainingMealDays}
//                                 </p>
//                             )}
//                         </div>

//                         <div className="bg-blue-100 p-3 rounded-lg border border-blue-200">
//                             <p className="text-blue-800 text-sm">
//                                 <span className="font-medium">Note:</span> Current date and next 2 days are not available for extension selection.
//                             </p>
//                         </div>

//                         <div className="border border-green-200 rounded-lg p-4">
//                             <div className="flex justify-between items-center mb-4">
//                                 <button
//                                     onClick={() => navigateMonth(-1)}
//                                     className="p-2 hover:bg-green-100 rounded text-green-700"
//                                 >
//                                     <ChevronDown className="rotate-90" size={20} />
//                                 </button>
//                                 <h3 className="text-lg font-semibold text-green-800">{monthYear}</h3>
//                                 <button
//                                     onClick={() => navigateMonth(1)}
//                                     className="p-2 hover:bg-green-100 rounded text-green-700"
//                                 >
//                                     <ChevronDown className="-rotate-90" size={20} />
//                                 </button>
//                             </div>

//                             <div className="grid grid-cols-7 gap-1 mb-2">
//                                 {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
//                                     <div key={day} className="text-center text-sm font-medium text-green-700 py-2">
//                                         {day}
//                                     </div>
//                                 ))}
//                             </div>

//                             <div className="grid grid-cols-7 gap-1">
//                                 {days.map((date, index) => (
//                                     <button
//                                         key={index}
//                                         onClick={() => handleDateClick(date)}
//                                         disabled={isDateDisabled(date)}
//                                         className={getDateClassName(date)}
//                                         title={
//                                             date && isDateInNonClickableRange(date)
//                                                 ? "This date is not available for extension"
//                                                 : ""
//                                         }
//                                     >
//                                         {date?.getDate()}
//                                     </button>
//                                 ))}
//                             </div>
//                         </div>

//                         {selectedDate && (
//                             <div className="bg-blue-100 p-4 rounded-lg border border-blue-200">
//                                 <h4 className="font-medium text-blue-800 mb-2">Selected Extension Date:</h4>
//                                 <div className="flex flex-wrap gap-2">
//                                     <span className="bg-blue-200 text-blue-800 px-3 py-1 rounded-full text-sm">
//                                         {new Date(selectedDate).toLocaleDateString('en-US', {
//                                             weekday: 'long',
//                                             month: 'short',
//                                             day: 'numeric'
//                                         })}
//                                     </span>
//                                 </div>
//                             </div>
//                         )}

//                         {error && (
//                             <div className="bg-red-100 p-3 rounded-lg text-red-700 text-sm border border-red-200">
//                                 {error}
//                             </div>
//                         )}

//                         <div className="flex justify-end space-x-3">
//                             <button
//                                 onClick={onClose}
//                                 className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition"
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleConfirmExtension}
//                                 disabled={!selectedDate}
//                                 className={`px-4 py-2 rounded transition ${!selectedDate
//                                     ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
//                                     : 'bg-green-600 text-white hover:bg-green-700'
//                                     }`}
//                             >
//                                 Confirm Extension
//                             </button>
//                         </div>
//                     </div>
//                 ) : error ? (
//                     <div className="text-center py-8">
//                         <p className="text-red-600">{error}</p>
//                         <button
//                             onClick={fetchExtensionDetails}
//                             className="mt-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
//                         >
//                             Retry
//                         </button>
//                     </div>
//                 ) : (
//                     <div className="text-center py-8">
//                         <p className="text-red-600">Failed to load extension details. Please try again.</p>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// // Address Modal Component
// const AddressModal = ({ isOpen, onClose, onSubmit, initialAddress = null }) => {
//     const [address, setAddress] = useState(initialAddress || {
//         streetName:initialAddress?.streetName || initialAddress?.location || '',
//         buildingName: '',
//         flatNumber: '',
//         city: '',
//         phoneNumber: '',
//         landmark:'',
//         latitude: initialAddress?.latitude || null,
//         longitude: initialAddress?.longitude || null,
//         addressType: "",
//     });

//     const emirateOptions = [
//         "Abu Dhabi",
//         "Dubai",
//         "Sharjah",
//         "Ajman",
//         "Umm Al Quwain",
//         "Ras Al Khaimah",
//         "Fujairah",
//         "Al Ain",
//         "Ruwais",
//         "Liwa Oasis",
//         "Delma Island",
//         "Sir Bani Yas Island"
//     ];

//     useEffect(() => {
//         if (initialAddress) {
//             setAddress(initialAddress);
//         } else {
//             // Reset form when adding a new address
//             setAddress({
//                 streetName: '',
//                 buildingName: '',
//                 flatNumber: '',
//                 city: '',
//                 phoneNumber: '',
//                 landmark:'',
//                 latitude: null,
//                 longitude: null,
//                 addressType:""
//             });
//         }
//     }, [initialAddress, isOpen]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setAddress(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleLocationSelect = (location) => {
//         // Always set location as string and lat/lng as numbers
//         const lat = Number(location.lat ?? location.latitude);
//         const lng = Number(location.lng ?? location.longitude);

//         console.log('DEBUG location selected:', location);
        
//         // Extract street name from different possible location in the location object
//         const streetName = location.streetName || 
//                           (location.address ? location.address.split(',')[0].trim() : '') ||
//                           (location.location ? location.location.split(',')[0].trim() : '');
        
//         // First, update the basic location data
//         const updatedAddress = {
//             latitude: isFinite(lat) ? lat : null,
//             longitude: isFinite(lng) ? lng : null,
//             location: location.address || location.location || '',
//             streetName: streetName
//         };

//         // If we have a formatted address, try to extract components
//         if (location.address) {
//             // Try to extract street name from the formatted address
//             const addressParts = location.address.split(',').map(part => part.trim());
//             if (addressParts.length > 0) {
//                 updatedAddress.streetName = addressParts[0];
//             }
            
//             // The second part is often the building/area name
//             if (addressParts.length > 1 && !updatedAddress.buildingName) {
//                 updatedAddress.buildingName = addressParts[1];
//             }
//         }

//         // Update state with the basic location data first
//         setAddress(prev => ({
//             ...prev,
//             ...updatedAddress
//         }));

//         // Then do reverse geocoding for more detailed address components
//         if (window.google) {
//             const geocoder = new window.google.maps.Geocoder();
//             geocoder.geocode({ location }, (results, status) => {
//                 if (status === 'OK' && results[0]) {
//                     const addr = results[0].address_components;
//                     const addressUpdate = {};

//                     // Extract address components
//                     addr.forEach(component => {
//                         const types = component.types;
                        
//                         if (types.includes('route')) {
//                             addressUpdate.streetName = component.long_name;
//                         } 
//                         else if ((types.includes('sublocality_level_1') || types.includes('locality')) && !addressUpdate.buildingName) {
//                             addressUpdate.buildingName = component.long_name;
//                         }
//                         else if (types.includes('administrative_area_level_2')) {
//                             addressUpdate.city = component.long_name;
//                         }
//                         else if (types.includes('administrative_area_level_1')) {
//                             addressUpdate.state = component.long_name;
//                         }
//                         // For UAE, we can also look for specific area names
//                         else if (types.includes('neighborhood')) {
//                             addressUpdate.area = component.long_name;
//                         }
//                     });

//                     // Update the address with the extracted components
//                     setAddress(prev => ({
//                         ...prev,
//                         ...addressUpdate
//                     }));
//                 }
//             });
//         }
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         console.log('AddressModal handleSubmit called');
//         toast.info('Submitting address...');
//         if (!address.location) {
//            alert('Please select a location on the map');
//             return;
//         }
//         console.log('DEBUG lat/lng before submit:', address.latitude, address.longitude);
//         // if (
//         //     address.latitude === null ||
//         //     address.longitude === null ||
//         //     address.latitude === undefined ||
//         //     address.longitude === undefined ||
//         //     address.latitude === '' ||
//         //     address.longitude === ''
//         // ) {
//         //     toast.error('Please select a location on the map.');
//         //     return;
//         // }
//         // if (!address.street || !address.city || !address.phone) {
//         //     toast.error('Please fill in all required fields');
//         //     return;
//         // }
//         onSubmit({
//             ...address,
//             latitude: address.latitude,
//             longitude: address.longitude
//         });
//         onClose();
//     };

//     if (!isOpen) return null;

//     return (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//             <div className="bg-white p-6 rounded-lg lg:w-full sm:max-w-md  lg:max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
//                 <div className="flex justify-between items-center mb-4">
//                     <h2 className="text-xl font-semibold text-green-800">
//                         {initialAddress ? 'Edit Address' : 'Add New Address'}
//                      </h2>
//                     <button
//                         onClick={onClose}
//                         className="text-gray-400 hover:text-gray-600"
//                     >
//                         <X size={24} />
//                     </button>
//                 </div>
                
//                 <form onSubmit={handleSubmit} className="space-y-6">
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                             Location on Map <span className="text-red-500">*</span>
//                         </label>
//                         <MapPicker 
//                             onLocationSelect={handleLocationSelect}
//                             initialLocation={
                             
//                                 address.latitude && address.longitude
//                                     ? { lat: address.latitude, lng: address.longitude, address: address.location }
//                                     : undefined
//                             }
//                         />
//                         <p className="mt-1 text-sm text-gray-500">
//                             Click on the map or search to set your exact location
//                         </p>
//                         {((address.lat === null || address.lng === null || address.latitude === undefined || address.longitude === undefined || address.latitude === '' || address.longitude === '') && (
//                             <p className="mt-2 text-sm text-red-600 font-semibold">Please select a location on the map before saving.</p>
//                         ))}
//                     </div>
                    
//               <div>
//   <label className="block text-sm font-medium text-gray-700">
//     Street <span className="text-red-500">*</span>
//   </label>
//   <input
//     type="text"
//     name="streetName"
//     value={address.streetName} // only street here
//     onChange={handleChange}
//     className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500"
//     required
//   />
// </div>

                    
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-1">Building Name</label>
//                         <input
//                             type="text"
//                             name="buildingName"
//                             value={address.buildingName}
//                             onChange={handleChange}
//                             placeholder="Building Name"
//                             className="w-full p-2 border border-green-300 rounded focus:ring-2 focus:ring-green-500 focus:border-green-500"
//                             required
//                         />
//                     </div>
                    
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-1">House/Flat Number</label>
//                         <input
//                             type="text"
//                             name="flatNumber"
//                             value={address.flatNumber}
//                             onChange={handleChange}
//                             placeholder="House/Flat Number"
//                             className="w-full p-2 border border-green-300 rounded focus:ring-2 focus:ring-green-500 focus:border-green-500"
//                             required
//                         />
//                     </div>
                    
//                   <div>
//   <label className="block text-sm font-medium text-gray-700 mb-1">Emirate</label>
//   <select
//     name="city"
//     value={address.city}
//     onChange={handleChange}
//     className="w-full p-2 border border-green-300 rounded focus:ring-2 focus:ring-green-500 focus:border-green-500"
//     required
//   >
//     <option value="">Select Emirate</option>
//     {emirateOptions.map((emirate, index) => (
//       <option key={index} value={emirate}>
//         {emirate}
//       </option>
//     ))}
//   </select>
// </div>

                    
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
//                         <input
//                             type="tel"
//                             name="phoneNumber"
//                             value={address.phoneNumber}
//                             onChange={handleChange}
//                             placeholder="Phone Number"
//                             className="w-full p-2 border border-green-300 rounded focus:ring-2 focus:ring-green-500 focus:border-green-500"
//                             required
//                         />
//                     </div>

//                       <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-1">landmark</label>
//                         <input
//                             type="text"
//                             name="landmark"
//                             value={address.landmark}
//                             onChange={handleChange}
//                             placeholder="Home, Work, etc."
//                             className="w-full p-2 border border-green-300 rounded focus:ring-2 focus:ring-green-500 focus:border-green-500"
//                         />
//                     </div>
                    
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-1">Address Type (Optional)</label>
//                         <input
//                             type="text"
//                             name="addressType"
//                             value={address.addressType}
//                             onChange={handleChange}
//                             placeholder="Home, Work, etc."
//                             className="w-full p-2 border border-green-300 rounded focus:ring-2 focus:ring-green-500 focus:border-green-500"
//                         />
//                     </div>
                    
//                     <div className="flex justify-between items-center pt-4 border-t border-gray-200">
//                         <div className="text-sm text-gray-500">
//                             <span className="text-red-500">*</span> Required fields
//                         </div>
//                         <div className="space-x-3">
//                             <button
//                                 type="button"
//                                 onClick={onClose}
//                                 className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 type="submit"
//                                 className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
//                             >
//                                 {initialAddress ? 'Update' : 'Add'} Address
//                             </button>
//                         </div>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// // Profile Edit Modal Component
// const ProfileEditModal = ({ isOpen, onClose, userData, onProfileUpdate }) => {
//     const [formData, setFormData] = useState({
//         phone: '',
//         countryCode: '+971',
//         dateOfBirth: '',
//         gender: '',
//         bio: '',
//         preferences: {
//             dietaryRestrictions: [],
//             allergies: [],
//             fitnessGoals: []
//         }
//     });
//     const [loading, setLoading] = useState(false);
//     const [errors, setErrors] = useState({});

//     useEffect(() => {
//         if (userData && isOpen) {
//             setFormData({
//                 phone: userData.phone || '',
//                 countryCode: userData.countryCode || '+971',
//                 dateOfBirth: userData.dateOfBirth ? userData.dateOfBirth.split('T')[0] : '',
//                 gender: userData.gender || '',
//                 bio: userData.bio || '',
//                 preferences: userData.preferences || {
//                     dietaryRestrictions: [],
//                     allergies: [],
//                     fitnessGoals: []
//                 }
//             });
//         }
//     }, [userData, isOpen]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handlePreferenceChange = (category, value, checked) => {
//         setFormData(prev => ({
//             ...prev,
//             preferences: {
//                 ...prev.preferences,
//                 [category]: checked
//                     ? [...prev.preferences[category], value]
//                     : prev.preferences[category].filter(item => item !== value)
//             }
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setErrors({});

//         try {
//             const formDataToSend = new FormData();
            
//             // Add only changed fields
//             Object.keys(formData).forEach(key => {
//                 if (key === 'preferences') {
//                     formDataToSend.append(key, JSON.stringify(formData[key]));
//                 } else if (formData[key] !== userData[key]) {
//                     formDataToSend.append(key, formData[key]);
//                 }
//             });

//             const response = await axios.patch(
//                 'https://api.dailyfit.ae/api/user/update-profile',
//                 formDataToSend,
//                 {
//                     withCredentials: true,
//                     headers: {
//                         'Content-Type': 'multipart/form-data'
//                     }
//                 }
//             );

//             if (response.data.status) {
//                 toast.success('Profile updated successfully!');
//                 onProfileUpdate(response.data.data);
//                 onClose();
//             }
//         } catch (err) {
//             console.error('Error updating profile', err);
//             if (err.response?.data?.errors) {
//                 setErrors(err.response.data.errors);
//                 toast.error('Please fix the validation errors');
//             } else {
//                 toast.error('Failed to update profile. Please try again.');
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     if (!isOpen) return null;

//     const dietaryOptions = ['vegetarian', 'vegan', 'gluten-free', 'dairy-free', 'keto', 'paleo'];
//     const allergyOptions = ['nuts', 'shellfish', 'eggs', 'milk', 'soy', 'wheat'];
//     const fitnessGoalOptions = ['weight_loss', 'muscle_gain', 'endurance', 'flexibility', 'maintenance'];

//     return (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//             <div className="bg-white p-6 rounded-lg w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
//                 <div className="flex justify-between items-center mb-6">
//                     <h2 className="text-2xl font-bold text-green-800">Edit Profile</h2>
//                     <button
//                         onClick={onClose}
//                         className="text-gray-400 hover:text-gray-600 transition-colors"
//                     >
//                         <X size={24} />
//                     </button>
//                 </div>

//                 <form onSubmit={handleSubmit} className="space-y-6">
//                     {/* Personal Information */}
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Phone Number
//                             </label>
//                             <input
//                                 type="tel"
//                                 name="phone"
//                                 value={formData.phone}
//                                 onChange={handleChange}
//                                 placeholder="+971501234567"
//                                 className="w-full p-3 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
//                             />
//                             {errors.phone && (
//                                 <p className="text-red-600 text-sm mt-1">{errors.phone}</p>
//                             )}
//                         </div>

//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Country Code
//                             </label>
//                             <select
//                                 name="countryCode"
//                                 value={formData.countryCode}
//                                 onChange={handleChange}
//                                 className="w-full p-3 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
//                             >
//                                 <option value="+971">+971 (UAE)</option>
//                                 <option value="+966">+966 (KSA)</option>
//                                 <option value="+965">+965 (Kuwait)</option>
//                                 <option value="+974">+974 (Qatar)</option>
//                                 <option value="+973">+973 (Bahrain)</option>
//                                 <option value="+968">+968 (Oman)</option>
//                             </select>
//                         </div>

//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Date of Birth
//                             </label>
//                             <input
//                                 type="date"
//                                 name="dateOfBirth"
//                                 value={formData.dateOfBirth}
//                                 onChange={handleChange}
//                                 className="w-full p-3 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
//                             />
//                         </div>

//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Gender
//                             </label>
//                             <select
//                                 name="gender"
//                                 value={formData.gender}
//                                 onChange={handleChange}
//                                 className="w-full p-3 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
//                             >
//                                 <option value="">Select Gender</option>
//                                 <option value="male">Male</option>
//                                 <option value="female">Female</option>
//                                 <option value="other">Other</option>
//                             </select>
//                             {errors.gender && (
//                                 <p className="text-red-600 text-sm mt-1">{errors.gender}</p>
//                             )}
//                         </div>
//                     </div>

//                     {/* Bio */}
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                             Bio
//                         </label>
//                         <textarea
//                             name="bio"
//                             value={formData.bio}
//                             onChange={handleChange}
//                             placeholder="Tell us about yourself, your fitness journey, and dietary preferences..."
//                             rows="4"
//                             className="w-full p-3 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
//                         />
//                     </div>

//                     {/* Dietary Preferences */}
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-3">
//                             Dietary Restrictions
//                         </label>
//                         <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
//                             {dietaryOptions.map(option => (
//                                 <label key={option} className="flex items-center space-x-2">
//                                     <input
//                                         type="checkbox"
//                                         checked={formData.preferences.dietaryRestrictions.includes(option)}
//                                         onChange={(e) => handlePreferenceChange('dietaryRestrictions', option, e.target.checked)}
//                                         className="rounded text-green-600 focus:ring-green-500"
//                                     />
//                                     <span className="text-sm text-gray-700 capitalize">{option.replace('-', ' ')}</span>
//                                 </label>
//                             ))}
//                         </div>
//                     </div>

//                     {/* Allergies */}
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-3">
//                             Allergies
//                         </label>
//                         <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
//                             {allergyOptions.map(option => (
//                                 <label key={option} className="flex items-center space-x-2">
//                                     <input
//                                         type="checkbox"
//                                         checked={formData.preferences.allergies.includes(option)}
//                                         onChange={(e) => handlePreferenceChange('allergies', option, e.target.checked)}
//                                         className="rounded text-green-600 focus:ring-green-500"
//                                     />
//                                     <span className="text-sm text-gray-700 capitalize">{option}</span>
//                                 </label>
//                             ))}
//                         </div>
//                     </div>

//                     {/* Fitness Goals */}
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-3">
//                             Fitness Goals
//                         </label>
//                         <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
//                             {fitnessGoalOptions.map(option => (
//                                 <label key={option} className="flex items-center space-x-2">
//                                     <input
//                                         type="checkbox"
//                                         checked={formData.preferences.fitnessGoals.includes(option)}
//                                         onChange={(e) => handlePreferenceChange('fitnessGoals', option, e.target.checked)}
//                                         className="rounded text-green-600 focus:ring-green-500"
//                                     />
//                                     <span className="text-sm text-gray-700 capitalize">{option.replace('_', ' ')}</span>
//                                 </label>
//                             ))}
//                         </div>
//                     </div>

//                     {/* Action Buttons */}
//                     <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
//                         <button
//                             type="button"
//                             onClick={onClose}
//                             className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             type="submit"
//                             disabled={loading}
//                             className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
//                         >
//                             {loading ? (
//                                 <>
//                                     <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
//                                     Updating...
//                                 </>
//                             ) : (
//                                 <>
//                                     <Save size={18} className="mr-2" />
//                                     Update Profile
//                                 </>
//                             )}
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// // Profile Image Upload Component
// const ProfileImageUpload = ({ userData, onImageUpdate }) => {
//     const [uploading, setUploading] = useState(false);
//     const [previewUrl, setPreviewUrl] = useState(userData?.profileImage || '');

//     const handleImageChange = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         // Validate file type
//         if (!file.type.startsWith('image/')) {
//             toast.error('Please select a valid image file');
//             return;
//         }

//         // Validate file size (max 5MB)
//         if (file.size > 5 * 1024 * 1024) {
//             toast.error('Image size should be less than 5MB');
//             return;
//         }

//         setUploading(true);
        
//         // Create preview
//         const reader = new FileReader();
//         reader.onload = (e) => {
//             setPreviewUrl(e.target.result);
//         };
//         reader.readAsDataURL(file);

//         try {
//             const formData = new FormData();
//             formData.append('files', file);

//             const response = await axios.patch(
//                 'https://api.dailyfit.ae/api/user/update-profile',
//                 formData,
//                 {
//                     withCredentials: true,
//                     headers: {
//                         'Content-Type': 'multipart/form-data'
//                     }
//                 }
//             );

//             if (response.data.status) {
//                 toast.success('Profile image updated successfully!');
//                 onImageUpdate(response.data.data);
//             }
//         } catch (err) {
//             console.error('Error uploading profile image', err);
//             toast.error('Failed to upload profile image. Please try again.');
//             // Revert preview on error
//             setPreviewUrl(userData?.profileImage || '');
//         } finally {
//             setUploading(false);
//         }
//     };

//     const getInitials = (name) => {
//         if (!name) return "";
//         const parts = name.trim().split(" ");
//         if (parts.length === 1) return parts[0][0].toUpperCase();
//         return (parts[0][0] + parts[1][0]).toUpperCase();
//     };

//     return (
//         <div className="flex flex-col items-center space-y-4">
//             <div className="relative">
//                 {previewUrl ? (
//                     <img
//                         src={previewUrl}
//                         alt="Profile"
//                         className="h-32 w-32 rounded-full object-cover border-4 border-white shadow-lg"
//                     />
//                 ) : (
//                     <div className="h-32 w-32 rounded-full bg-gradient-to-r from-green-400 to-green-600 flex items-center justify-center text-white text-4xl font-bold border-4 border-white shadow-lg">
//                         {getInitials(userData?.userName)}
//                     </div>
//                 )}
                
//                 <label 
//                     htmlFor="profileImageUpload"
//                     className={`absolute bottom-0 right-0 bg-green-600 text-white p-2 rounded-full shadow-lg cursor-pointer hover:bg-green-700 transition-colors ${uploading ? 'opacity-50 cursor-not-allowed' : ''}`}
//                 >
//                     {uploading ? (
//                         <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
//                     ) : (
//                         <Camera size={16} />
//                     )}
//                 </label>
                
//                 <input
//                     id="profileImageUpload"
//                     type="file"
//                     accept="image/*"
//                     onChange={handleImageChange}
//                     disabled={uploading}
//                     className="hidden"
//                 />
//             </div>
            
//             <div className="text-center">
//                 <h3 className="text-lg font-semibold text-green-800">{userData?.userName}</h3>
//                 <p className="text-gray-600 text-sm">{userData?.userEmail}</p>
//                 <p className="text-green-600 text-xs mt-1">
//                     {uploading ? 'Uploading...' : 'Click camera icon to update photo'}
//                 </p>
//             </div>
//         </div>
//     );
// };

// // Main User Profile Component
// const UserProfile = () => {
//     const [activeTab, setActiveTab] = useState('profile');
//     const [profileData, setProfileData] = useState(null);
//     const [expandedOrderId, setExpandedOrderId] = useState(null);
//     const [packageDetails, setPackageDetails] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [paymentStatusFilter, setPaymentStatusFilter] = useState(-1);
//     const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
//     const [editingAddress, setEditingAddress] = useState(null);
//     const [isExtensionModalOpen, setIsExtensionModalOpen] = useState(false);
//     const [selectedOrderForExtension, setSelectedOrderForExtension] = useState(null);
//     const [isProfileEditModalOpen, setIsProfileEditModalOpen] = useState(false);

//     useEffect(() => {
//         const loadRazorpayScript = () => {
//             return new Promise((resolve) => {
//                 const script = document.createElement('script');
//                 script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//                 script.onload = () => {
//                     resolve(true);
//                 };
//                 script.onerror = () => {
//                     resolve(false);
//                 };
//                 document.body.appendChild(script);
//             });
//         };

//         loadRazorpayScript();
//     }, []);

//     useEffect(() => {
//         const fetchProfileData = async () => {
//             try {
//                 setLoading(true);
//                 const response = await axios.get('https://api.dailyfit.ae/api/user/get-profile', { withCredentials: true });
//                 setProfileData(response.data.data);
//                 setLoading(false);
//             } catch (err) {
//                 setError(err);
//                 setLoading(false);
//             }
//         };

//         fetchProfileData();
//     }, []);

//     const fetchPackageDetails = async (orderID) => {
//         if (packageDetails[orderID]) return packageDetails[orderID];

//         try {
//             const response = await axios.post(
//                 'https://api.dailyfit.ae/api/user/get-order-meal-details',
//                 { orderID },
//                 { withCredentials: true }
//             );

//             if (
//                 response.data?.status === true &&
//                 response.data?.data &&
//                 Object.keys(response.data.data).length === 0
//             ) {
//                 toast.info("No meal details available for this order.");
//             }

//             setPackageDetails(prev => ({
//                 ...prev,
//                 [orderID]: response.data
//             }));

//             return response.data;
//         } catch (err) {
//             console.error('Error fetching package details', err);
//             toast.error("Failed to load meal details. Please try again.");
//             return null;
//         }
//     };

//     const handleExpandOrder = async (order) => {
//         if (expandedOrderId === order.orderID) {
//             setExpandedOrderId(null);
//             return;
//         }

//         await fetchPackageDetails(order.orderID);
//         setExpandedOrderId(order.orderID);
//     };

//     const handleAddAddress = async (newAddress) => {
//         console.log("handleAddAddress called");
        
//         // Create a copy of newAddress and remove the location field
//         const { location, ...addressWithoutLocation } = newAddress;
        
//         const payload = {
//             address: addressWithoutLocation
//         };
        
//         console.log('Address payload (location removed):', payload);
        
//         try {
//             const response = await axios.post(
//                 'https://api.dailyfit.ae/api/user/add-address',
//                 payload,
//                 { withCredentials: true }
//             );
        
//             const addedAddress = response?.data?.data || newAddress;
//             setProfileData(prev => ({
//                 ...prev,
//                 savedAddress: [...prev.savedAddress, addedAddress]
//             }));
//         } catch (err) {
//             console.error('Error adding address', err);
//         }
//     };

//     const handleEditAddress = async (updatedAddress) => {
//         try {
//             const requestBody = {
//                 identifier: updatedAddress.identifier,
//                 address: {
//                     ...updatedAddress
//                 }
//             };

//             await axios.patch('https://api.dailyfit.ae/api/user/update-address',
//                 requestBody,
//                 { withCredentials: true }
//             );

//             setProfileData(prev => ({
//                 ...prev,
//                 savedAddress: prev.savedAddress.map(addr =>
//                     addr.identifier === updatedAddress.identifier ? updatedAddress : addr
//                 )
//             }));
//         } catch (err) {
//             console.error('Error updating address', err);
//         }
//     };

//     const openEditAddressModal = (address) => {
//         setEditingAddress(address);
//         setIsAddressModalOpen(true);
//     };

//     const handleDeleteAddress = async (addressToDelete) => {
//         try {
//             await axios.delete('https://api.dailyfit.ae/api/user/delete-address', {
//                 data: { identifier: addressToDelete.identifier },
//                 withCredentials: true
//             });

//             setProfileData(prev => ({
//                 ...prev,
//                 savedAddress: prev.savedAddress.filter(addr =>
//                     addr.identifier !== addressToDelete.identifier
//                 )
//             }));
//         } catch (err) {
//             console.error('Error deleting address', err);
//         }
//     };

//     const handleExtensionDateClick = (orderID) => {
//         setSelectedOrderForExtension(orderID);
//         setIsExtensionModalOpen(true);
//     };

//     const handleExtensionConfirm = async (orderID, selectedDates) => {
//         try {
//             const extendedDate = selectedDates[selectedDates.length - 1];
//             const response = await axios.post('https://api.dailyfit.ae/api/user/extend-order', {
//                 orderID: orderID,
//                 extendedDate: extendedDate.toISOString()
//             }, { withCredentials: true });

//             if (response.data.success) {
//                 setProfileData(prev => ({
//                     ...prev,
//                     orders: prev.orders.map(order =>
//                         order?.orderID === orderID
//                             ? { ...order, extendedDate: extendedDate }
//                             : order
//                     )
//                 }));

//                 alert('Extension confirmed successfully!');
//                 setIsExtensionModalOpen(false);
//                 setSelectedOrderForExtension(null);
//             }
//         } catch (err) {
//             console.error('Error confirming extension', err);
//             alert('Failed to confirm extension. Please try again.');
//         }
//     };

//     const handlePayNow = async (order) => {
//         try {
//             if (!order.RazorPayOrderDetails || !order.RazorPayOrderDetails.id) {
//                 console.error('Missing RazorPay order details');
//                 return;
//             }

//             const options = {
//                 key: "your_razorpay_key_id",
//                 amount: order.RazorPayOrderDetails.amount,
//                 currency: order.RazorPayOrderDetails.currency,
//                 name: "DailyFit",
//                 description: `Payment for Order ID: ${order.orderID}`,
//                 order_id: order.RazorPayOrderDetails.id,
//                 handler: function (response) {
//                     verifyPayment(response, order.orderID);
//                 },
//                 prefill: {
//                     name: profileData.userName,
//                     email: profileData.userEmail,
//                     contact: profileData.phone || ""
//                 },
//                 theme: {
//                     color: "#16a34a"
//                 }
//             };

//             const rzp = new window.Razorpay(options);
//             rzp.open();
//         } catch (err) {
//             console.error('Error initiating payment', err);
//         }
//     };

//     const handleRetryPayment = (order) => {
//         handlePayNow(order);
//     };

//     const verifyPayment = async (paymentResponse, orderID) => {
//         try {
//             const response = await axios.post(
//                 'https://api.dailyfit.ae/api/user/verify-payment',
//                 {
//                     orderID: orderID,
//                     paymentID: paymentResponse.razorpay_payment_id,
//                     razorpay_order_id: paymentResponse.razorpay_order_id,
//                     razorpay_signature: paymentResponse.razorpay_signature
//                 },
//                 { withCredentials: true }
//             );

//             if (response.data.status) {
//                 setProfileData(prev => ({
//                     ...prev,
//                     orders: prev.orders.map(order =>
//                         order?.orderID === orderID
//                             ? { ...order, paymentStatus: 1 }
//                             : order
//                     )
//                 }));

//                 alert('Payment successful!');
//             } else {
//                 alert('Payment verification failed. Please try again.');
//             }
//         } catch (err) {
//             console.error('Payment verification error', err);
//             alert('Payment verification failed. Please try again.');
//         }
//     };

//     const handleLogout = async () => {
//         try {
//             await axios.post('https://api.dailyfit.ae/api/user/logout', {}, { withCredentials: true });
//             window.location.href = '/Order';
//         } catch (err) {
//             console.error('Logout error', err);
//         }
//     };

//     const getInitials = (name) => {
//         if (!name) return "";
//         const parts = name.trim().split(" ");
//         if (parts.length === 1) return parts[0][0].toUpperCase();
//         return (parts[0][0] + parts[1][0]).toUpperCase();
//     };

//     // Handle profile updates
//     const handleProfileUpdate = (updatedData) => {
//         setProfileData(prev => ({
//             ...prev,
//             ...updatedData
//         }));
//     };

//     // Handle profile image updates
//     const handleImageUpdate = (updatedData) => {
//         setProfileData(prev => ({
//             ...prev,
//             profileImage: updatedData.profileImage || prev.profileImage
//         }));
//     };

//     // Enhanced Personal Information Section with Edit Button
//     const EnhancedPersonalInfo = ({ user, onEditClick }) => {
//         return (
//             <div className="bg-white shadow-lg rounded-xl p-6 border border-green-200">
//                 <div className="flex justify-between items-start mb-6">
//                     <div>
//                         <h2 className="text-2xl font-bold text-green-800">Personal Information</h2>
//                         <p className="text-gray-600">Manage your personal details and preferences</p>
//                     </div>
//                     <button
//                         onClick={onEditClick}
//                         className="flex items-center text-green-600 hover:text-green-700 bg-green-50 hover:bg-green-100 px-4 py-2 rounded-lg transition-colors"
//                     >
//                         <Edit size={18} className="mr-2" />
//                         Edit Profile
//                     </button>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <div className="space-y-4">
//                         <div>
//                             <label className="text-sm font-medium text-gray-500">Full Name</label>
//                             <p className="text-lg text-gray-900">{user.userName}</p>
//                         </div>
//                         <div>
//                             <label className="text-sm font-medium text-gray-500">Email</label>
//                             <p className="text-lg text-gray-900">{user.userEmail}</p>
//                         </div>
//                         <div>
//                             <label className="text-sm font-medium text-gray-500">Phone</label>
//                             <p className="text-lg text-gray-900">
//                                 {user.phone ? `${user.countryCode || ''} ${user.phone}` : 'Not set'}
//                             </p>
//                         </div>
//                     </div>

//                     <div className="space-y-4">
//                         <div>
//                             <label className="text-sm font-medium text-gray-500">Date of Birth</label>
//                             <p className="text-lg text-gray-900">
//                                 {user.dateOfBirth ? new Date(user.dateOfBirth).toLocaleDateString() : 'Not set'}
//                             </p>
//                         </div>
//                         <div>
//                             <label className="text-sm font-medium text-gray-500">Gender</label>
//                             <p className="text-lg text-gray-900 capitalize">{user.gender || 'Not set'}</p>
//                         </div>
//                         <div>
//                             <label className="text-sm font-medium text-gray-500">Bio</label>
//                             <p className="text-lg text-gray-900">{user.bio || 'No bio added yet'}</p>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Preferences Section */}
//                 {user.preferences && (
//                     <div className="mt-8 pt-6 border-t border-gray-200">
//                         <h3 className="text-xl font-semibold text-green-800 mb-4">Preferences</h3>
//                         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                             <div>
//                                 <h4 className="font-medium text-gray-700 mb-2">Dietary Restrictions</h4>
//                                 <div className="flex flex-wrap gap-1">
//                                     {user.preferences.dietaryRestrictions?.length > 0 ? (
//                                         user.preferences.dietaryRestrictions.map(restriction => (
//                                             <span key={restriction} className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-sm capitalize">
//                                                 {restriction.replace('-', ' ')}
//                                             </span>
//                                         ))
//                                     ) : (
//                                         <span className="text-gray-500 text-sm">None specified</span>
//                                     )}
//                                 </div>
//                             </div>

//                             <div>
//                                 <h4 className="font-medium text-gray-700 mb-2">Allergies</h4>
//                                 <div className="flex flex-wrap gap-1">
//                                     {user.preferences.allergies?.length > 0 ? (
//                                         user.preferences.allergies.map(allergy => (
//                                             <span key={allergy} className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-sm capitalize">
//                                                 {allergy}
//                                             </span>
//                                         ))
//                                     ) : (
//                                         <span className="text-gray-500 text-sm">None specified</span>
//                                     )}
//                                 </div>
//                             </div>

//                             <div>
//                                 <h4 className="font-medium text-gray-700 mb-2">Fitness Goals</h4>
//                                 <div className="flex flex-wrap gap-1">
//                                     {user.preferences.fitnessGoals?.length > 0 ? (
//                                         user.preferences.fitnessGoals.map(goal => (
//                                             <span key={goal} className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-sm capitalize">
//                                                 {goal.replace('_', ' ')}
//                                             </span>
//                                         ))
//                                     ) : (
//                                         <span className="text-gray-500 text-sm">None specified</span>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );
//     };

//     if (loading) {
//         return (
//             <div className="flex justify-center items-center h-screen bg-green-50">
//                 <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-green-600"></div>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div className="flex justify-center items-center h-screen bg-green-50 text-red-600">
//                 <p>Error loading profile: {error.message}</p>
//             </div>
//         );
//     }

//     if (!profileData) {
//         return null;
//     }

//     return (
//         <div className="bg-gradient-to-b from-green-50 to-green-100 min-h-screen pb-12">
//             <Navigation />
//             <ToastContainer position="top-right" autoClose={3000} />

//             <div className="container mx-auto px-4 py-8 max-w-6xl">
//                 <div className="flex mb-8 bg-white rounded-xl shadow-md overflow-hidden">
//                     <button
//                         className={`flex-1 px-6 py-4 transition-colors font-medium ${activeTab === 'profile'
//                             ? 'bg-green-700 text-white shadow-inner'
//                             : 'text-green-700 hover:bg-green-50'
//                             }`}
//                         onClick={() => setActiveTab('profile')}
//                     >
//                         <div className="flex items-center justify-center">
//                             <UserCircle className="h-5 w-5 mr-2" />
//                             Profile & Addresses
//                         </div>
//                     </button>
//                     <button
//                         className={`flex-1 px-6 py-4 transition-colors font-medium ${activeTab === 'orders'
//                             ? 'bg-green-700 text-white shadow-inner'
//                             : 'text-green-700 hover:bg-green-50'
//                             }`}
//                         onClick={() => setActiveTab('orders')}
//                     >
//                         <div className="flex items-center justify-center">
//                             <ShoppingBag className="h-5 w-5 mr-2" />
//                             My Orders
//                         </div>
//                     </button>
//                 </div>

//                 {activeTab === 'profile' && (
//                     <div className="space-y-8">
//                         {/* Enhanced Profile Header with Image Upload */}
//                         <div className="bg-white shadow-xl rounded-2xl overflow-hidden border border-gray-100">
//                             <div className="bg-gradient-to-r from-green-500 to-green-900 p-8 text-white">
//                                 <div className="flex flex-col lg:flex-row items-center justify-between space-y-6 lg:space-y-0">
//                                     <div className="flex flex-col lg:flex-row items-center space-y-4 lg:space-y-0 lg:space-x-6">
//                                         <ProfileImageUpload 
//                                             userData={profileData} 
//                                             onImageUpdate={handleImageUpdate}
//                                         />
//                                         <div className="text-center lg:text-left">
//                                             <h1 className="text-3xl font-bold">{profileData.userName}</h1>
//                                             <p className="text-green-100 opacity-90">{profileData.userEmail}</p>
//                                             <p className="text-green-200 text-sm mt-2">
//                                                 Member since {new Date(profileData.createdAt).toLocaleDateString()}
//                                             </p>
//                                         </div>
//                                     </div>
//                                     <div className="flex space-x-3">
//                                         <button
//                                             onClick={() => setIsProfileEditModalOpen(true)}
//                                             className="bg-white text-green-700 px-4 py-2 rounded-lg font-semibold hover:bg-green-50 transition-colors flex items-center"
//                                         >
//                                             <Edit size={18} className="mr-2" />
//                                             Edit Profile
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Personal Information Card */}
//                         <EnhancedPersonalInfo 
//                             user={profileData} 
//                             onEditClick={() => setIsProfileEditModalOpen(true)}
//                         />

//                         {/* Address Section */}
//                         <div className="bg-white shadow-lg rounded-xl p-8 border-l-4 border-green-600 hover:shadow-xl transition-shadow duration-300">
//                             <div className="flex justify-between items-center mb-6">
//                                 <div className="flex items-center">
//                                     <div className="bg-green-100 p-3 rounded-full mr-4 border border-green-200">
//                                         <Home className="h-6 w-6 text-green-600" />
//                                     </div>
//                                     <h2 className="text-2xl font-bold text-green-800">Saved Addresses</h2>
//                                 </div>
//                                 <button
//                                     onClick={() => {
//                                         setEditingAddress(null);
//                                         setIsAddressModalOpen(true);
//                                     }}
//                                     className="flex items-center text-white bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg transition-colors shadow-md"
//                                 >
//                                     <Plus className="h-5 w-5 mr-2" />
//                                     Add New Address
//                                 </button>
//                             </div>

//                             <div className="grid md:grid-cols-2 gap-6">
//                                 {profileData.savedAddress?.map((address, index) => (
//                                     <div
//                                         key={index}
//                                         className="border border-green-200 rounded-lg p-4 flex justify-between items-center hover:bg-green-50 transition"
//                                     >
//                                         <div>
//                                             <p className="font-semibold text-green-900">{address.streetName}</p>
//                                             <p className="text-gray-600">{address.buildingFloor}, {address.houseOrFlatNumber}</p>
//                                             <p className="text-gray-600">{address.landmark}</p>
//                                             <p className="text-gray-600">
//                                                 {address.city}, {address.state} {address.postalCode}
//                                             </p>
//                                             <p className="text-gray-600">{address.country}</p>
//                                             <p className="text-gray-600">Phone: {address.phone}</p>
//                                         </div>
//                                         <div className="flex space-x-2">
//                                             <button
//                                                 onClick={() => openEditAddressModal(address)}
//                                                 className="text-green-600 hover:bg-green-100 p-2 rounded"
//                                             >
//                                                 <Edit size={20} />
//                                             </button>
//                                             <button
//                                                 onClick={() => handleDeleteAddress(address)}
//                                                 className="text-red-600 hover:bg-red-100 p-2 rounded"
//                                             >
//                                                 <Trash2 size={20} />
//                                             </button>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 {activeTab === 'orders' && (
//                     <div className="bg-white shadow-lg rounded-xl p-8 border-l-4 border-green-600 hover:shadow-xl transition-shadow duration-300">
//                         <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
//                             <div className="flex items-center">
//                                 <div className="bg-green-100 p-3 rounded-full mr-4 border border-green-200">
//                                     <ShoppingBag className="h-6 w-6 text-green-600" />
//                                 </div>
//                                 <h2 className="text-2xl font-bold text-green-800">My Orders</h2>
//                             </div>

//                             <div className="relative">
//                                 <select
//                                     className="appearance-none bg-green-50 border border-green-300 text-green-700 py-2 px-4 pr-8 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent cursor-pointer font-medium"
//                                     onChange={(e) => setPaymentStatusFilter(parseInt(e.target.value))}
//                                     value={paymentStatusFilter}
//                                 >
//                                     <option value="-1">All Orders</option>
//                                     <option value="0">Payment Pending</option>
//                                     <option value="1">Payment Successful</option>
//                                     <option value="2">Payment Failed</option>
//                                 </select>
//                                 <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-green-700">
//                                     <ChevronDown className="h-4 w-4" />
//                                 </div>
//                             </div>
//                         </div>

//                         {loading ? (
//                             <div className="text-center py-12">
//                                 <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-600"></div>
//                                 <p className="mt-4 text-green-700 font-medium">Loading your orders...</p>
//                             </div>
//                         ) : error ? (
//                             <div className="bg-red-100 p-4 rounded-lg text-center border border-red-200">
//                                 <div className="bg-white p-4 inline-block rounded-full mb-4">
//                                     <X className="h-10 w-10 text-red-500 mx-auto" />
//                                 </div>
//                                 <p className="text-red-700 font-medium">Something went wrong while loading your orders.</p>
//                                 <button className="mt-3 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors">
//                                     Try Again
//                                 </button>
//                             </div>
//                         ) : profileData?.orders?.length > 0 ? (
//                             <div className="space-y-6">
//                                 {profileData.orders
//                                     .filter(order => paymentStatusFilter === -1 || order.paymentStatus === paymentStatusFilter)
//                                     .map((order, index) => (
//                                         <div key={index} className="border border-green-200 rounded-xl overflow-hidden hover:shadow-lg transition duration-300">
//                                             <div
//                                                 className={`p-4 sm:p-6 ${expandedOrderId === order.orderID ? 'bg-green-50' : 'bg-white'} hover:bg-green-50 cursor-pointer transition-colors`}
//                                                 onClick={() => handleExpandOrder(order)}
//                                             >
//                                                 <div className="flex flex-col gap-4">
//                                                     <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//                                                         <div className="flex flex-wrap items-center gap-2 sm:gap-4">
//                                                             <div className="flex items-center">
//                                                                 <div className="bg-green-700 text-white rounded-l-lg px-2 py-1 sm:px-3 sm:py-2">
//                                                                     <ShoppingBag className="h-4 w-4 sm:h-5 sm:w-5" />
//                                                                 </div>
//                                                                 <div className="flex items-center gap-2">
//                                                                     <div className="bg-green-100 text-green-800 rounded-r-lg px-2 py-1 text-xs font-medium">
//                                                                         {order.orderID}
//                                                                     </div>
//                                                                     <span className="inline-block bg-green-700 text-white px-3 py-1 rounded-lg text-xs sm:text-sm font-medium">{order?.selectedMeals?.package?.plan?.mealPlanName}</span>
//                                                                 </div>
//                                                             </div>
//                                                             <span className="text-sm font-medium text-green-800">
//                                                                 {order.selectedPackage?.packageName || "Package"}
//                                                             </span>
//                                                         </div>

//                                                         <div className="flex items-center self-start sm:self-auto">
//                                                             <div className="bg-green-700 text-white px-2 py-1 sm:px-3 sm:py-2 rounded-l-lg text-xs sm:text-sm font-medium">
//                                                                 TOTAL
//                                                             </div>
//                                                             <div className="bg-green-600 text-white px-2 py-1 sm:px-3 sm:py-2 text-xs sm:text-sm font-bold">
//                                                                 AED
//                                                             </div>
//                                                             <div className="bg-green-100 text-green-800 px-2 py-1 sm:px-3 sm:py-2 rounded-r-lg text-xs sm:text-lg font-bold">
//                                                                 {order.amount}
//                                                             </div>
//                                                         </div>
//                                                     </div>

//                                                     <div className="flex flex-col sm:flex-row justify-between gap-4">
//                                                         <div className="flex flex-wrap gap-2 sm:gap-6">
//                                                             <div className="flex items-center bg-green-50 px-2 py-1 sm:px-3 sm:py-2 rounded-lg border border-green-200">
//                                                                 <Calendar className="h-4 w-4 sm:h-5 sm:w-5 mr-1 sm:mr-2 text-green-600" />
//                                                                 <div>
//                                                                     <span className="block text-xs text-green-600">Start</span>
//                                                                     <span className="text-xs sm:text-sm font-medium text-green-800">{order.startDate?.slice(0, 10) || order.selectedPackage?.startDate}</span>
//                                                                 </div>
//                                                             </div>
//                                                             <div className="flex items-center bg-green-50 px-2 py-1 sm:px-3 sm:py-2 rounded-lg border border-green-200">
//                                                                 <Calendar className="h-4 w-4 sm:h-5 sm:w-5 mr-1 sm:mr-2 text-green-600" />
//                                                                 <div>
//                                                                     <span className="block text-xs text-green-600">End</span>
//                                                                     <span className="text-xs sm:text-sm font-medium text-green-800">{order.endDate?.slice(0, 10) || order.selectedPackage?.endDate}</span>
//                                                                 </div>
//                                                             </div>
//                                                             <div className={`flex items-center px-2 py-1 sm:px-3 sm:py-2 rounded-lg border 
//                                                                 ${order.paymentStatus === 1 
//                                                                     ? 'bg-green-50 border-green-200 cursor-pointer hover:bg-green-100 transition-colors' 
//                                                                     : 'bg-gray-100 border-gray-200 cursor-not-allowed opacity-70'}`}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     // Only allow extension if payment is successful
//                                                                     if (order.paymentStatus === 1) {
//                                                                         handleExtensionDateClick(order.orderID);
//                                                                     }
//                                                                 }}
//                                                                 title={order.paymentStatus !== 1 ? "Complete your payment first to extend your meal plan" : "Extend your meal plan"}>
//                                                                 <Calendar className="h-4 w-4 sm:h-5 sm:w-5 mr-1 sm:mr-2 text-green-600" />
//                                                                 <div>
//                                                                     <span className="block text-xs text-green-600">Extend Date</span>
//                                                                     <span className="text-xs sm:text-sm font-medium text-green-800">
//                                                                         {order.extendedDate?.slice(0, 10) || 
//                                                                             (order.paymentStatus === 1 ? 'Click to extend' : 'Complete payment first')}
//                                                                     </span>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                         <div className="flex items-center">
//                                                             <div>
//                                                                 <div className="flex items-center">
//                                                                     {order.bagIncluded ? (
//                                                                         <>
//                                                                             <div className="h-4 w-4 sm:h-5 sm:w-5 text-green-600 mr-1 bg-green-100 rounded-full flex items-center justify-center">
//                                                                                 <div className="h-2 w-2 bg-green-600 rounded-full"></div>
//                                                                             </div>
//                                                                             <span className="text-xs sm:text-sm font-medium text-green-600">Bag Included</span>
//                                                                         </>
//                                                                     ) : (
//                                                                         <>
//                                                                             <div className="h-4 w-4 sm:h-5 sm:w-5 text-gray-400 mr-1 bg-gray-100 rounded-full flex items-center justify-center">
//                                                                                 <X className="h-3 w-3" />
//                                                                             </div>
//                                                                             <span className="text-xs sm:text-sm font-medium text-gray-500">Bag Not Included</span>
//                                                                         </>
//                                                                     )}
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>

//                                                     <div className="flex flex-wrap items-center justify-between gap-2 sm:gap-3 mt-2 sm:mt-0">
//                                                         <div className="flex flex-wrap items-center gap-2">
//                                                             {order.paymentStatus === 0 && (
//                                                                 <span className="bg-yellow-100 text-yellow-800 px-2 py-1 sm:px-3 sm:py-2 rounded-lg text-xs sm:text-sm font-medium flex items-center border border-yellow-200">
//                                                                     <div className="h-3 w-3 bg-yellow-500 rounded-full mr-2"></div>
//                                                                     Payment Pending
//                                                                 </span>
//                                                             )}
//                                                             {order.paymentStatus === 1 && (
//                                                                 <span className="bg-green-100 text-green-800 px-2 py-1 sm:px-3 sm:py-2 rounded-lg text-xs sm:text-sm font-medium inline-flex items-center border border-green-200">
//                                                                     <div className="h-3 w-3 bg-green-500 rounded-full mr-2"></div>
//                                                                     Payment Successful
//                                                                 </span>
//                                                             )}
//                                                             {order.paymentStatus === 2 && (
//                                                                 <span className="bg-red-100 text-red-800 px-2 py-1 sm:px-3 sm:py-2 rounded-lg text-xs sm:text-sm font-medium inline-flex items-center border border-red-200">
//                                                                     <div className="h-3 w-3 bg-red-500 rounded-full mr-2"></div>
//                                                                     Payment Failed
//                                                                 </span>
//                                                             )}
//                                                         </div>

//                                                         <div className="flex flex-wrap items-center gap-2">
//                                                             {order.paymentStatus === 0 && (
//                                                                 <button
//                                                                     onClick={(e) => {
//                                                                         e.stopPropagation();
//                                                                         handlePayNow(order);
//                                                                     }}
//                                                                     className="bg-green-600 hover:bg-green-700 text-white text-xs sm:text-sm font-medium px-3 py-1 sm:px-4 sm:py-2 rounded-lg transition shadow-md flex items-center"
//                                                                 >
//                                                                     <div className="h-4 w-4 sm:h-5 sm:w-5 mr-1 bg-white text-green-600 rounded-full flex items-center justify-center">
//                                                                         <div className="h-2 w-2 bg-green-600 rounded-full"></div>
//                                                                     </div>
//                                                                     Pay Now
//                                                                 </button>
//                                                             )}
//                                                             {order.paymentStatus === 2 && (
//                                                                 <button
//                                                                     onClick={(e) => {
//                                                                         e.stopPropagation();
//                                                                         handleRetryPayment(order);
//                                                                     }}
//                                                                     className="bg-green-600 hover:bg-green-700 text-white text-xs sm:text-sm font-medium px-3 py-1 sm:px-4 sm:py-2 rounded-lg transition shadow-md flex items-center"
//                                                                 >
//                                                                     <div className="h-4 w-4 sm:h-5 sm:w-5 mr-1 bg-white text-green-600 rounded-full flex items-center justify-center">
//                                                                         <div className="h-2 w-2 bg-green-600 rounded-full"></div>
//                                                                     </div>
//                                                                     Retry Payment
//                                                                 </button>
//                                                             )}

//                                                             <div className="ml-auto sm:ml-2">
//                                                                 {expandedOrderId === order.orderID ? (
//                                                                     <div className="bg-green-200 p-1 sm:p-2 rounded-full transition-transform duration-300 transform rotate-180 border border-green-300">
//                                                                         <ChevronDown className="h-5 w-5 sm:h-6 sm:w-6 text-green-700" />
//                                                                     </div>
//                                                                 ) : (
//                                                                     <div className="bg-green-200 p-1 sm:p-2 rounded-full transition-transform duration-300 border border-green-300">
//                                                                         <ChevronDown className="h-5 w-5 sm:h-6 sm:w-6 text-green-700" />
//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             {/* Table View for Package Details */}
//                                             {expandedOrderId === order.orderID && packageDetails[order?.orderID] && (
//                                                 <div className="p-4 bg-white border-t border-green-200">
//                                                     <div className="mb-6">
//                                                         <h3 className="text-lg font-semibold text-green-800 mb-4">Meal Details</h3>
                                                        
//                                                         {packageDetails[order?.orderID]?.data[0]?.selectedMeals
//                                                             ?.slice() // Create a copy of the array to avoid mutating the original
//                                                             .sort((a, b) => new Date(a.date) - new Date(b.date)) // Sort by date
//                                                             .map((dayMeal, index) => (
//                                                             <div key={index} className="mb-8">
//                                                                 <h4 className="text-md font-medium text-green-700 mb-3 bg-green-50 p-3 rounded-lg">
//                                                                     Meals for {new Date(dayMeal.date).toLocaleDateString('en-US', {
//                                                                         weekday: 'long',
//                                                                         month: 'long',
//                                                                         day: 'numeric'
//                                                                     })}
//                                                                 </h4>
                                                                
//                                                                 <div className="overflow-x-auto">
//                                                                     <table className="min-w-full bg-white border border-green-200 rounded-lg">
//                                                                         <thead className="bg-green-600 text-white">
//                                                                             <tr>
//                                                                                 <th className="py-3 px-4 text-left" rowSpan="2">Meal</th>
//                                                                                 <th className="py-3 px-4 text-left" rowSpan="2">Type</th>
//                                                                                 <th className="py-3 px-4 text-center" colSpan="2">Portion Details</th>
//                                                                                 <th className="py-3 px-4 text-center" rowSpan="2">Calories</th>
//                                                                                 <th className="py-3 px-4 text-center" colSpan="3">Nutrition per Portion</th>
//                                                                                 <th className="py-3 px-4 text-left" rowSpan="2">Allergens</th>
//                                                                             </tr>
//                                                                             <tr>
//                                                                                 <th className="py-3 px-2 text-center text-sm">Portion</th>
//                                                                                 <th className="py-3 px-2 text-center text-sm">Weight</th>
//                                                                                 <th className="py-3 px-2 text-center text-sm">Protein (g)</th>
//                                                                                 <th className="py-3 px-2 text-center text-sm">Carbs (g)</th>
//                                                                                 <th className="py-3 px-2 text-center text-sm">Fat (g)</th>
//                                                                             </tr>
//                                                                         </thead>
//                                                                         <tbody>
//                                                                             {dayMeal.meals.map((meal, idx) => (
//                                                                                 <tr key={idx} className={idx % 2 === 0 ? 'bg-green-50' : 'bg-white'}>
//                                                                                     <td className="py-3 px-4 border-b border-green-200">
//                                                                                         <div className="flex items-center">
//                                                                                             {meal.image?.[0] && (
//                                                                                                 <img 
//                                                                                                     src={meal.image[0]} 
//                                                                                                     alt={meal.mealName} 
//                                                                                                     className="h-10 w-10 object-cover rounded mr-3"
//                                                                                                 />
//                                                                                             )}
//                                                                                             <div>
//                                                                                                 <div className="font-medium text-green-900">{meal.mealName}</div>
//                                                                                                 <div className="text-sm text-gray-600 line-clamp-1">{meal.description}</div>
//                                                                                             </div>
//                                                                                         </div>
//                                                                                     </td>
//                                                                                     <td className="py-3 px-4 border-b border-green-200">
//                                                                                         {meal.mealType?.[0]?.mealType && (
//                                                                                             <span className="bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded">
//                                                                                                 {meal.mealType[0].mealType}
//                                                                                             </span>
//                                                                                         )}
//                                                                                     </td>
//                                                                                     <td className="py-3 px-4 border-b border-green-200 text-center">
//                                                                                         {meal.portionDetails?.portion || 'N/A'}
//                                                                                     </td>
//                                                                                     <td className="py-3 px-4 border-b border-green-200 text-center">
//                                                                                         {meal.portionDetails?.weight || 'N/A'}
//                                                                                     </td>
//                                                                                     <td className="py-3 px-4 border-b border-green-200 text-center font-medium">
//                                                                                         {meal.moreDetails.energy} kcal
//                                                                                     </td>
//                                                                                     <td className="py-3 px-4 border-b border-green-200 text-center font-medium">
//                                                                                         {meal.moreDetails.protein}g
//                                                                                     </td>
//                                                                                     <td className="py-3 px-4 border-b border-green-200 text-center font-medium">
//                                                                                         {meal.moreDetails.carbohydrates}g
//                                                                                     </td>
//                                                                                     <td className="py-3 px-4 border-b border-green-200 text-center font-medium">
//                                                                                         {meal.moreDetails.fat}g
//                                                                                     </td>
//                                                                                     <td className="py-3 px-4 border-b border-green-200">
//                                                                                         {meal.moreDetails.allergens?.length > 0 ? (
//                                                                                             <span className="text-red-600 text-sm">
//                                                                                                 {meal.moreDetails.allergens.join(', ')}
//                                                                                             </span>
//                                                                                         ) : (
//                                                                                             <span className="text-green-600 text-sm">None</span>
//                                                                                         )}
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             ))}
//                                                                         </tbody>
//                                                                     </table>
//                                                                 </div>
//                                                             </div>
//                                                         ))}
//                                                     </div>

//                                                     {packageDetails[order?.orderID]?.data[0]?.addons?.length > 0 && (
//                                                         <div>
//                                                             <h3 className="text-lg font-semibold text-green-800 mb-4">Addon Products</h3>
//                                                             <div className="overflow-x-auto">
//                                                                 <table className="min-w-full bg-white border border-green-200 rounded-lg">
//                                                                     <thead className="bg-purple-600 text-white">
//                                                                         <tr>
//                                                                             <th className="py-3 px-4 text-left">Product</th>
//                                                                             <th className="py-3 px-4 text-left">Description</th>
//                                                                         </tr>
//                                                                     </thead>
//                                                                     <tbody>
//                                                                         {packageDetails[order?.orderID]?.data[0]?.addons?.map((addon, idx) => (
//                                                                             <tr key={idx} className={idx % 2 === 0 ? 'bg-purple-50' : 'bg-white'}>
//                                                                                 <td className="py-3 px-4 border-b border-purple-200">
//                                                                                     <div className="flex items-center">
//                                                                                         {addon.image?.[0] && addon.image[0] !== "" ? (
//                                                                                             <img 
//                                                                                                 src={addon.image[0]} 
//                                                                                                 alt={addon.mealName} 
//                                                                                                 className="h-10 w-10 object-cover rounded mr-3"
//                                                                                             />
//                                                                                         ) : (
//                                                                                             <div className="h-10 w-10 bg-purple-100 rounded mr-3 flex items-center justify-center text-purple-400">
//                                                                                                 📷
//                                                                                             </div>
//                                                                                         )}
//                                                                                         <div className="font-medium text-purple-900">{addon.mealName}</div>
//                                                                                     </div>
//                                                                                 </td>
//                                                                                 <td className="py-3 px-4 border-b border-purple-200 text-sm text-gray-600">
//                                                                                     {addon.description}
//                                                                                 </td>
//                                                                             </tr>
//                                                                         ))}
//                                                                     </tbody>
//                                                                 </table>
//                                                             </div>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             )}
//                                         </div>
//                                     ))}
//                             </div>
//                         ) : (
//                             <div className="text-center py-12 bg-green-50 rounded-xl border border-green-200">
//                                 <div className="bg-white p-4 inline-block rounded-full mb-4 border border-green-200">
//                                     <ShoppingBag className="h-12 w-12 text-green-500" />
//                                 </div>
//                                 <h3 className="text-xl font-semibold text-green-800 mb-2">No Orders Yet</h3>
//                                 <p className="text-gray-600 mb-6">You haven't placed any orders yet. Start exploring our meal packages!</p>
//                                 <button className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg transition-colors shadow-md font-medium flex items-center justify-center mx-auto">
//                                     <ShoppingBag className="h-5 w-5 mr-2" />
//                                     Browse Packages
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                 )}

//                 <AddressModal
//                     isOpen={isAddressModalOpen}
//                     onClose={() => setIsAddressModalOpen(false)}
//                     onSubmit={async (address) => {
//                         if (editingAddress) {
//                             await handleEditAddress(address);
//                         } else {
//                             await handleAddAddress(address);
//                         }
//                     }}
//                     initialAddress={editingAddress}
//                 />

//                 <ExtensionModal
//                     isOpen={isExtensionModalOpen}
//                     onClose={() => {
//                         setIsExtensionModalOpen(false);
//                         setSelectedOrderForExtension(null);
//                     }}
//                     orderID={selectedOrderForExtension}
//                     onExtensionConfirm={handleExtensionConfirm}
//                 />

//                 <ProfileEditModal
//                     isOpen={isProfileEditModalOpen}
//                     onClose={() => setIsProfileEditModalOpen(false)}
//                     userData={profileData}
//                     onProfileUpdate={handleProfileUpdate}
//                 />
//             </div>
//         </div>
//     );
// };

// export default UserProfile;






import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    ChevronDown, ChevronUp, Plus, Edit, Trash2,
    Home, ShoppingBag, UserCircle, Settings, LogOut,
    Calendar, X, Camera, Save, Upload
} from 'lucide-react';
import logo from '../images/logo.png';
import Navigation from './mealListNavigation';
import PersonalInfoCard from '../components/personalifo_card';
import AddressList from '../components/AddressList';
import MapPicker from '../components/MapPicker';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Extension Modal Component
const ExtensionModal = ({ isOpen, onClose, orderID, onExtensionConfirm }) => {
    const [extensionDetails, setExtensionDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [error, setError] = useState(null);

    useEffect(() => {
        if (isOpen && orderID) {
            fetchExtensionDetails();
        }
    }, [isOpen, orderID]);

    const fetchExtensionDetails = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await axios.post('https://api.dailyfit.ae/api/user/get-extension-details', {
                orderID: orderID
            }, { withCredentials: true });

            setExtensionDetails(response.data.data);
            setSelectedDate(null);
        } catch (err) {
            console.error('Error fetching extension details', err);
            setError('Failed to load extension details. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const getDaysInMonth = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();
        const startingDayOfWeek = firstDay.getDay();

        const days = [];

        for (let i = 0; i < startingDayOfWeek; i++) {
            days.push(null);
        }

        for (let day = 1; day <= daysInMonth; day++) {
            days.push(new Date(year, month, day));
        }

        return days;
    };

    const handleDateClick = (date) => {
        if (!date || !extensionDetails) return;

        const dateString = date.toISOString();
        const extendableUpto = new Date(extensionDetails.extendableUpto);
        extendableUpto.setHours(23, 59, 59, 999);

        if (date > extendableUpto) {
            setError(`You can only extend up to ${extendableUpto.toLocaleDateString()}`);
            return;
        }

        if (isDateInNonClickableRange(date)) {
            return;
        }

        setSelectedDate(dateString);
        setError(null);
    };

    const isDateSelected = (date) => {
        if (!date) return false;
        if (!selectedDate) return false;

        const dateString = date.toISOString().split('T')[0];
        const selectedDateString = new Date(selectedDate).toISOString().split('T')[0];
        return dateString === selectedDateString;
    };

    const isDateInNonClickableRange = (date) => {
        if (!date) return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const twoDaysFromToday = new Date(today);
        twoDaysFromToday.setDate(today.getDate() + 2);
        twoDaysFromToday.setHours(23, 59, 59, 999);

        const checkDate = new Date(date);
        checkDate.setHours(0, 0, 0, 0);

        return checkDate >= today && checkDate <= twoDaysFromToday;
    };

    const isDateDisabled = (date) => {
        if (!date || !extensionDetails) return true;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (date < today) return true;

        const extendableUpto = new Date(extensionDetails.extendableUpto);
        extendableUpto.setHours(23, 59, 59, 999);
        if (date > extendableUpto) return true;

        if (isDateInNonClickableRange(date)) return true;

        return false;
    };

    const getDateClassName = (date) => {
        if (!date) return 'invisible';

        let className = 'h-10 w-10 text-sm rounded-lg transition-colors ';

        if (isDateDisabled(date)) {
            if (isDateInNonClickableRange(date)) {
                className += 'bg-gray-200 text-gray-500 cursor-not-allowed border-2 border-gray-300';
            } else {
                className += 'text-gray-300 cursor-not-allowed';
            }
        } else {
            className += 'text-gray-700 hover:bg-green-100 cursor-pointer';
        }

        if (isDateSelected(date)) {
            className += ' bg-green-600 text-white hover:bg-green-700';
        }

        return className;
    };

    const handleConfirmExtension = async () => {
        if (!selectedDate) {
            setError('Please select a date for extension');
            return;
        }

        try {
            const response = await axios.post(
                'https://api.dailyfit.ae/api/user/extend-order',
                {
                    orderID: orderID,
                    extendedDate: selectedDate
                },
                { withCredentials: true }
            );

            if (response.data.status) {
                onExtensionConfirm(orderID, [selectedDate]);
                onClose();
            } else {
                setError(response.data.message || 'Extension failed. Please try again.');
            }
        } catch (err) {
            console.error('Error confirming extension', err);
            setError('Failed to confirm extension. Please try again.');
        }
    };

    const navigateMonth = (direction) => {
        setCurrentDate(prev => {
            const newDate = new Date(prev);
            newDate.setMonth(prev.getMonth() + direction);
            return newDate;
        });
    };

    if (!isOpen) return null;

    const days = getDaysInMonth(currentDate);
    const monthYear = currentDate.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric'
    });

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold text-green-800">
                        Extend Your Meal Plan
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600"
                    >
                        <X size={24} />
                    </button>
                </div>

                {loading ? (
                    <div className="flex justify-center py-8">
                        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-green-600"></div>
                    </div> 
                ) : extensionDetails ? (
                    <div className="space-y-6">
                        <div className="bg-green-100 p-4 rounded-lg border border-green-200">
                            <p className="text-green-800 font-medium">
                                You can extend your meal plan by <span className="font-bold">1 day</span>
                            </p>
                            <p className="text-sm text-green-700 mt-1">
                                Extendable up to: {new Date(extensionDetails.extendableUpto).toLocaleDateString()}
                            </p>
                            {extensionDetails.remainingMealDays && (
                                <p className="text-sm text-green-700 mt-1">
                                    Remaining meal days: {extensionDetails.remainingMealDays}
                                </p>
                            )}
                        </div>

                        <div className="bg-blue-100 p-3 rounded-lg border border-blue-200">
                            <p className="text-blue-800 text-sm">
                                <span className="font-medium">Note:</span> Current date and next 2 days are not available for extension selection.
                            </p>
                        </div>

                        <div className="border border-green-200 rounded-lg p-4">
                            <div className="flex justify-between items-center mb-4">
                                <button
                                    onClick={() => navigateMonth(-1)}
                                    className="p-2 hover:bg-green-100 rounded text-green-700"
                                >
                                    <ChevronDown className="rotate-90" size={20} />
                                </button>
                                <h3 className="text-lg font-semibold text-green-800">{monthYear}</h3>
                                <button
                                    onClick={() => navigateMonth(1)}
                                    className="p-2 hover:bg-green-100 rounded text-green-700"
                                >
                                    <ChevronDown className="-rotate-90" size={20} />
                                </button>
                            </div>

                            <div className="grid grid-cols-7 gap-1 mb-2">
                                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                                    <div key={day} className="text-center text-sm font-medium text-green-700 py-2">
                                        {day}
                                    </div>
                                ))}
                            </div>

                            <div className="grid grid-cols-7 gap-1">
                                {days.map((date, index) => (
                                    <button
                                        key={index}
                                        onClick={() => handleDateClick(date)}
                                        disabled={isDateDisabled(date)}
                                        className={getDateClassName(date)}
                                        title={
                                            date && isDateInNonClickableRange(date)
                                                ? "This date is not available for extension"
                                                : ""
                                        }
                                    >
                                        {date?.getDate()}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {selectedDate && (
                            <div className="bg-blue-100 p-4 rounded-lg border border-blue-200">
                                <h4 className="font-medium text-blue-800 mb-2">Selected Extension Date:</h4>
                                <div className="flex flex-wrap gap-2">
                                    <span className="bg-blue-200 text-blue-800 px-3 py-1 rounded-full text-sm">
                                        {new Date(selectedDate).toLocaleDateString('en-US', {
                                            weekday: 'long',
                                            month: 'short',
                                            day: 'numeric'
                                        })}
                                    </span>
                                </div>
                            </div>
                        )}

                        {error && (
                            <div className="bg-red-100 p-3 rounded-lg text-red-700 text-sm border border-red-200">
                                {error}
                            </div>
                        )}

                        <div className="flex justify-end space-x-3">
                            <button
                                onClick={onClose}
                                className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleConfirmExtension}
                                disabled={!selectedDate}
                                className={`px-4 py-2 rounded transition ${!selectedDate
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    : 'bg-green-600 text-white hover:bg-green-700'
                                    }`}
                            >
                                Confirm Extension
                            </button>
                        </div>
                    </div>
                ) : error ? (
                    <div className="text-center py-8">
                        <p className="text-red-600">{error}</p>
                        <button
                            onClick={fetchExtensionDetails}
                            className="mt-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                        >
                            Retry
                        </button>
                    </div>
                ) : (
                    <div className="text-center py-8">
                        <p className="text-red-600">Failed to load extension details. Please try again.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

// Address Modal Component
const AddressModal = ({ isOpen, onClose, onSubmit, initialAddress = null }) => {
    const [address, setAddress] = useState(initialAddress || {
        streetName:initialAddress?.streetName || initialAddress?.location || '',
        buildingName: '',
        flatNumber: '',
        city: '',
        phoneNumber: '',
        landmark:'',
        latitude: initialAddress?.latitude || null,
        longitude: initialAddress?.longitude || null,
        addressType: "",
    });

    const emirateOptions = [
        "Abu Dhabi",
        "Dubai",
        "Sharjah",
        "Ajman",
        "Umm Al Quwain",
        "Ras Al Khaimah",
        "Fujairah",
        "Al Ain",
        "Ruwais",
        "Liwa Oasis",
        "Delma Island",
        "Sir Bani Yas Island"
    ];

    useEffect(() => {
        if (initialAddress) {
            setAddress(initialAddress);
        } else {
            // Reset form when adding a new address
            setAddress({
                streetName: '',
                buildingName: '',
                flatNumber: '',
                city: '',
                phoneNumber: '',
                landmark:'',
                latitude: null,
                longitude: null,
                addressType:""
            });
        }
    }, [initialAddress, isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAddress(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleLocationSelect = (location) => {
        // Always set location as string and lat/lng as numbers
        const lat = Number(location.lat ?? location.latitude);
        const lng = Number(location.lng ?? location.longitude);

        console.log('DEBUG location selected:', location);
        
        // Extract street name from different possible location in the location object
        const streetName = location.streetName || 
                          (location.address ? location.address.split(',')[0].trim() : '') ||
                          (location.location ? location.location.split(',')[0].trim() : '');
        
        // First, update the basic location data
        const updatedAddress = {
            latitude: isFinite(lat) ? lat : null,
            longitude: isFinite(lng) ? lng : null,
            location: location.address || location.location || '',
            streetName: streetName
        };

        // If we have a formatted address, try to extract components
        if (location.address) {
            // Try to extract street name from the formatted address
            const addressParts = location.address.split(',').map(part => part.trim());
            if (addressParts.length > 0) {
                updatedAddress.streetName = addressParts[0];
            }
            
            // The second part is often the building/area name
            if (addressParts.length > 1 && !updatedAddress.buildingName) {
                updatedAddress.buildingName = addressParts[1];
            }
        }

        // Update state with the basic location data first
        setAddress(prev => ({
            ...prev,
            ...updatedAddress
        }));

        // Then do reverse geocoding for more detailed address components
        if (window.google) {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location }, (results, status) => {
                if (status === 'OK' && results[0]) {
                    const addr = results[0].address_components;
                    const addressUpdate = {};

                    // Extract address components
                    addr.forEach(component => {
                        const types = component.types;
                        
                        if (types.includes('route')) {
                            addressUpdate.streetName = component.long_name;
                        } 
                        else if ((types.includes('sublocality_level_1') || types.includes('locality')) && !addressUpdate.buildingName) {
                            addressUpdate.buildingName = component.long_name;
                        }
                        else if (types.includes('administrative_area_level_2')) {
                            addressUpdate.city = component.long_name;
                        }
                        else if (types.includes('administrative_area_level_1')) {
                            addressUpdate.state = component.long_name;
                        }
                        // For UAE, we can also look for specific area names
                        else if (types.includes('neighborhood')) {
                            addressUpdate.area = component.long_name;
                        }
                    });

                    // Update the address with the extracted components
                    setAddress(prev => ({
                        ...prev,
                        ...addressUpdate
                    }));
                }
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('AddressModal handleSubmit called');
        toast.info('Submitting address...');
        if (!address.location) {
           alert('Please select a location on the map');
            return;
        }
        console.log('DEBUG lat/lng before submit:', address.latitude, address.longitude);
        onSubmit({
            ...address,
            latitude: address.latitude,
            longitude: address.longitude
        });
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg lg:w-full sm:max-w-md  lg:max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold text-green-800">
                        {initialAddress ? 'Edit Address' : 'Add New Address'}
                     </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600"
                    >
                        <X size={24} />
                    </button>
                </div>
                
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Location on Map <span className="text-red-500">*</span>
                        </label>
                        <MapPicker 
                            onLocationSelect={handleLocationSelect}
                            initialLocation={
                             
                                address.latitude && address.longitude
                                    ? { lat: address.latitude, lng: address.longitude, address: address.location }
                                    : undefined
                            }
                        />
                        <p className="mt-1 text-sm text-gray-500">
                            Click on the map or search to set your exact location
                        </p>
                        {((address.lat === null || address.lng === null || address.latitude === undefined || address.longitude === undefined || address.latitude === '' || address.longitude === '') && (
                            <p className="mt-2 text-sm text-red-600 font-semibold">Please select a location on the map before saving.</p>
                        ))}
                    </div>
                    
              <div>
  <label className="block text-sm font-medium text-gray-700">
    Street <span className="text-red-500">*</span>
  </label>
  <input
    type="text"
    name="streetName"
    value={address.streetName} // only street here
    onChange={handleChange}
    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500"
    required
  />
</div>

                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Building Name</label>
                        <input
                            type="text"
                            name="buildingName"
                            value={address.buildingName}
                            onChange={handleChange}
                            placeholder="Building Name"
                            className="w-full p-2 border border-green-300 rounded focus:ring-2 focus:ring-green-500 focus:border-green-500"
                            required
                        />
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">House/Flat Number</label>
                        <input
                            type="text"
                            name="flatNumber"
                            value={address.flatNumber}
                            onChange={handleChange}
                            placeholder="House/Flat Number"
                            className="w-full p-2 border border-green-300 rounded focus:ring-2 focus:ring-green-500 focus:border-green-500"
                            required
                        />
                    </div>
                    
                  <div>
  <label className="block text-sm font-medium text-gray-700 mb-1">Emirate</label>
  <select
    name="city"
    value={address.city}
    onChange={handleChange}
    className="w-full p-2 border border-green-300 rounded focus:ring-2 focus:ring-green-500 focus:border-green-500"
    required
  >
    <option value="">Select Emirate</option>
    {emirateOptions.map((emirate, index) => (
      <option key={index} value={emirate}>
        {emirate}
      </option>
    ))}
  </select>
</div>

                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                        <input
                            type="tel"
                            name="phoneNumber"
                            value={address.phoneNumber}
                            onChange={handleChange}
                            placeholder="Phone Number"
                            className="w-full p-2 border border-green-300 rounded focus:ring-2 focus:ring-green-500 focus:border-green-500"
                            required
                        />
                    </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">landmark</label>
                        <input
                            type="text"
                            name="landmark"
                            value={address.landmark}
                            onChange={handleChange}
                            placeholder="Home, Work, etc."
                            className="w-full p-2 border border-green-300 rounded focus:ring-2 focus:ring-green-500 focus:border-green-500"
                        />
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Address Type (Optional)</label>
                        <input
                            type="text"
                            name="addressType"
                            value={address.addressType}
                            onChange={handleChange}
                            placeholder="Home, Work, etc."
                            className="w-full p-2 border border-green-300 rounded focus:ring-2 focus:ring-green-500 focus:border-green-500"
                        />
                    </div>
                    
                    <div className="flex justify-between items-center pt-4 border-t border-gray-200">
                        <div className="text-sm text-gray-500">
                            <span className="text-red-500">*</span> Required fields
                        </div>
                        <div className="space-x-3">
                            <button
                                type="button"
                                onClick={onClose}
                                className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                            >
                                {initialAddress ? 'Update' : 'Add'} Address
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

// Profile Edit Modal Component
const ProfileEditModal = ({ isOpen, onClose, userData, onProfileUpdate }) => {
    const [formData, setFormData] = useState({
        phone: '',
        countryCode: '+971',
        dateOfBirth: '',
        gender: '',
        bio: '',
        preferences: {
            dietaryRestrictions: [],
            allergies: [],
            fitnessGoals: []
        }
    });
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (userData && isOpen) {
            // Parse preferences if they come as string from API
            let parsedPreferences = {
                dietaryRestrictions: [],
                allergies: [],
                fitnessGoals: []
            };
            
            if (userData.preferences) {
                if (typeof userData.preferences === 'string') {
                    try {
                        parsedPreferences = JSON.parse(userData.preferences);
                    } catch (err) {
                        console.error('Error parsing preferences:', err);
                    }
                } else {
                    parsedPreferences = userData.preferences;
                }
            }

            setFormData({
                phone: userData.phone || '',
                countryCode: userData.countryCode || '+971',
                dateOfBirth: userData.dateOfBirth ? userData.dateOfBirth.split('T')[0] : '',
                gender: userData.gender || '',
                bio: userData.bio || '',
                preferences: parsedPreferences
            });
        }
    }, [userData, isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePreferenceChange = (category, value, checked) => {
        setFormData(prev => ({
            ...prev,
            preferences: {
                ...prev.preferences,
                [category]: checked
                    ? [...prev.preferences[category], value]
                    : prev.preferences[category].filter(item => item !== value)
            }
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors({});

        try {
            const updateData = {};
            
            // Add only changed fields
            if (formData.phone !== userData.phone) updateData.phone = formData.phone;
            if (formData.countryCode !== userData.countryCode) updateData.countryCode = formData.countryCode;
            if (formData.dateOfBirth !== userData.dateOfBirth) updateData.dateOfBirth = formData.dateOfBirth;
            if (formData.gender !== userData.gender) updateData.gender = formData.gender;
            if (formData.bio !== userData.bio) updateData.bio = formData.bio;
            
            // Handle preferences - always send as object
            const currentPrefsString = JSON.stringify(formData.preferences);
            const originalPrefsString = typeof userData.preferences === 'string' 
                ? userData.preferences 
                : JSON.stringify(userData.preferences || {});
            
            if (currentPrefsString !== originalPrefsString) {
                updateData.preferences = formData.preferences;
            }

            // Check if there are any fields to update
            if (Object.keys(updateData).length === 0) {
                toast.info('No changes detected');
                setLoading(false);
                return;
            }

            console.log('Sending update data:', updateData);

            const response = await axios.patch(
                'https://api.dailyfit.ae/api/user/update-profile',
                updateData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data.status) {
                toast.success('Profile updated successfully!');
                onProfileUpdate(response.data.data);
                onClose();
            }
        } catch (err) {
            console.error('Error updating profile', err);
            if (err.response?.data?.errors) {
                setErrors(err.response.data.errors);
                toast.error('Please fix the validation errors');
            } else if (err.response?.data?.message) {
                toast.error(err.response.data.message);
            } else {
                toast.error('Failed to update profile. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    const dietaryOptions = ['vegetarian', 'vegan', 'gluten-free', 'dairy-free', 'keto', 'paleo'];
    const allergyOptions = ['nuts', 'shellfish', 'eggs', 'milk', 'soy', 'wheat'];
    const fitnessGoalOptions = ['weight_loss', 'muscle_gain', 'endurance', 'flexibility', 'maintenance'];

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-green-800">Edit Profile</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X size={24} />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    {/* Personal Information */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Phone Number
                            </label>
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="+971501234567"
                                className="w-full p-3 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                            />
                            {errors.phone && (
                                <p className="text-red-600 text-sm mt-1">{errors.phone}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Country Code
                            </label>
                            <select
                                name="countryCode"
                                value={formData.countryCode}
                                onChange={handleChange}
                                className="w-full p-3 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                            >
                                <option value="+971">+971 (UAE)</option>
                                <option value="+966">+966 (KSA)</option>
                                <option value="+965">+965 (Kuwait)</option>
                                <option value="+974">+974 (Qatar)</option>
                                <option value="+973">+973 (Bahrain)</option>
                                <option value="+968">+968 (Oman)</option>
                            </select>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Date of Birth
                            </label>
                            <input
                                type="date"
                                name="dateOfBirth"
                                value={formData.dateOfBirth}
                                onChange={handleChange}
                                className="w-full p-3 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Gender
                            </label>
                            <select
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                className="w-full p-3 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                            >
                                <option value="">Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                            </select>
                            {errors.gender && (
                                <p className="text-red-600 text-sm mt-1">{errors.gender}</p>
                            )}
                        </div>
                    </div>

                    {/* Bio */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Bio
                        </label>
                        <textarea
                            name="bio"
                            value={formData.bio}
                            onChange={handleChange}
                            placeholder="Tell us about yourself, your fitness journey, and dietary preferences..."
                            rows="4"
                            className="w-full p-3 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                        />
                    </div>

                    {/* Dietary Preferences */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">
                            Dietary Restrictions
                        </label>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                            {dietaryOptions.map(option => (
                                <label key={option} className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        checked={formData.preferences.dietaryRestrictions.includes(option)}
                                        onChange={(e) => handlePreferenceChange('dietaryRestrictions', option, e.target.checked)}
                                        className="rounded text-green-600 focus:ring-green-500"
                                    />
                                    <span className="text-sm text-gray-700 capitalize">{option.replace('-', ' ')}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    {/* Allergies */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">
                            Allergies
                        </label>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                            {allergyOptions.map(option => (
                                <label key={option} className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        checked={formData.preferences.allergies.includes(option)}
                                        onChange={(e) => handlePreferenceChange('allergies', option, e.target.checked)}
                                        className="rounded text-green-600 focus:ring-green-500"
                                    />
                                    <span className="text-sm text-gray-700 capitalize">{option}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    {/* Fitness Goals */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">
                            Fitness Goals
                        </label>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                            {fitnessGoalOptions.map(option => (
                                <label key={option} className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        checked={formData.preferences.fitnessGoals.includes(option)}
                                        onChange={(e) => handlePreferenceChange('fitnessGoals', option, e.target.checked)}
                                        className="rounded text-green-600 focus:ring-green-500"
                                    />
                                    <span className="text-sm text-gray-700 capitalize">{option.replace('_', ' ')}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                        >
                            {loading ? (
                                <>
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                    Updating...
                                </>
                            ) : (
                                <>
                                    <Save size={18} className="mr-2" />
                                    Update Profile
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

// Profile Image Upload Component
const ProfileImageUpload = ({ userData, onImageUpdate }) => {
    const [uploading, setUploading] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(userData?.profileImage || '');

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate file type
        if (!file.type.startsWith('image/')) {
            toast.error('Please select a valid image file');
            return;
        }

        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
            toast.error('Image size should be less than 5MB');
            return;
        }

        setUploading(true);
        
        // Create preview
        const reader = new FileReader();
        reader.onload = (e) => {
            setPreviewUrl(e.target.result);
        };
        reader.readAsDataURL(file);

        try {
            const formData = new FormData();
            formData.append('files', file);

            const response = await axios.patch(
                'https://api.dailyfit.ae/api/user/update-profile',
                formData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            if (response.data.status) {
                toast.success('Profile image updated successfully!');
                onImageUpdate(response.data.data);
            }
        } catch (err) {
            console.error('Error uploading profile image', err);
            toast.error('Failed to upload profile image. Please try again.');
            // Revert preview on error
            setPreviewUrl(userData?.profileImage || '');
        } finally {
            setUploading(false);
        }
    };

    const getInitials = (name) => {
        if (!name) return "";
        const parts = name.trim().split(" ");
        if (parts.length === 1) return parts[0][0].toUpperCase();
        return (parts[0][0] + parts[1][0]).toUpperCase();
    };

    return (
        <div className="flex flex-col items-center space-y-4">
            <div className="relative">
                {previewUrl ? (
                    <img
                        src={previewUrl}
                        alt="Profile"
                        className="h-32 w-32 rounded-full object-cover border-4 border-white shadow-lg"
                    />
                ) : (
                    <div className="h-32 w-32 rounded-full bg-gradient-to-r from-green-400 to-green-600 flex items-center justify-center text-white text-4xl font-bold border-4 border-white shadow-lg">
                        {getInitials(userData?.userName)}
                    </div>
                )}
                
                <label 
                    htmlFor="profileImageUpload"
                    className={`absolute bottom-0 right-0 bg-green-600 text-white p-2 rounded-full shadow-lg cursor-pointer hover:bg-green-700 transition-colors ${uploading ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                    {uploading ? (
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    ) : (
                        <Camera size={16} />
                    )}
                </label>
                
                <input
                    id="profileImageUpload"
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    disabled={uploading}
                    className="hidden"
                />
            </div>
            
            <div className="text-center">
                <h3 className="text-lg font-semibold text-green-800">{userData?.userName}</h3>
                <p className="text-gray-600 text-sm">{userData?.userEmail}</p>
                <p className="text-green-600 text-xs mt-1">
                    {uploading ? 'Uploading...' : 'Click camera icon to update photo'}
                </p>
            </div>
        </div>
    );
};

// Main User Profile Component
const UserProfile = () => {
    const [activeTab, setActiveTab] = useState('profile');
    const [profileData, setProfileData] = useState(null);
    const [expandedOrderId, setExpandedOrderId] = useState(null);
    const [packageDetails, setPackageDetails] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [paymentStatusFilter, setPaymentStatusFilter] = useState(-1);
    const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
    const [editingAddress, setEditingAddress] = useState(null);
    const [isExtensionModalOpen, setIsExtensionModalOpen] = useState(false);
    const [selectedOrderForExtension, setSelectedOrderForExtension] = useState(null);
    const [isProfileEditModalOpen, setIsProfileEditModalOpen] = useState(false);

    useEffect(() => {
        const loadRazorpayScript = () => {
            return new Promise((resolve) => {
                const script = document.createElement('script');
                script.src = 'https://checkout.razorpay.com/v1/checkout.js';
                script.onload = () => {
                    resolve(true);
                };
                script.onerror = () => {
                    resolve(false);
                };
                document.body.appendChild(script);
            });
        };

        loadRazorpayScript();
    }, []);

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setLoading(true);
                const response = await axios.get('https://api.dailyfit.ae/api/user/get-profile', { withCredentials: true });
                setProfileData(response.data.data);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchProfileData();
    }, []);

    const fetchPackageDetails = async (orderID) => {
        if (packageDetails[orderID]) return packageDetails[orderID];

        try {
            const response = await axios.post(
                'https://api.dailyfit.ae/api/user/get-order-meal-details',
                { orderID },
                { withCredentials: true }
            );

            if (
                response.data?.status === true &&
                response.data?.data &&
                Object.keys(response.data.data).length === 0
            ) {
                toast.info("No meal details available for this order.");
            }

            setPackageDetails(prev => ({
                ...prev,
                [orderID]: response.data
            }));

            return response.data;
        } catch (err) {
            console.error('Error fetching package details', err);
            toast.error("Failed to load meal details. Please try again.");
            return null;
        }
    };

    const handleExpandOrder = async (order) => {
        if (expandedOrderId === order.orderID) {
            setExpandedOrderId(null);
            return;
        }

        await fetchPackageDetails(order.orderID);
        setExpandedOrderId(order.orderID);
    };

    const handleAddAddress = async (newAddress) => {
        console.log("handleAddAddress called");
        
        // Create a copy of newAddress and remove the location field
        const { location, ...addressWithoutLocation } = newAddress;
        
        const payload = {
            address: addressWithoutLocation
        };
        
        console.log('Address payload (location removed):', payload);
        
        try {
            const response = await axios.post(
                'https://api.dailyfit.ae/api/user/add-address',
                payload,
                { withCredentials: true }
            );
        
            const addedAddress = response?.data?.data || newAddress;
            setProfileData(prev => ({
                ...prev,
                savedAddress: [...prev.savedAddress, addedAddress]
            }));
            toast.success('Address added successfully!');
        } catch (err) {
            console.error('Error adding address', err);
            toast.error('Failed to add address. Please try again.');
        }
    };

    const handleEditAddress = async (updatedAddress) => {
        try {
            const requestBody = {
                identifier: updatedAddress.identifier,
                address: {
                    ...updatedAddress
                }
            };

            await axios.patch('https://api.dailyfit.ae/api/user/update-address',
                requestBody,
                { withCredentials: true }
            );

            setProfileData(prev => ({
                ...prev,
                savedAddress: prev.savedAddress.map(addr =>
                    addr.identifier === updatedAddress.identifier ? updatedAddress : addr
                )
            }));
            toast.success('Address updated successfully!');
        } catch (err) {
            console.error('Error updating address', err);
            toast.error('Failed to update address. Please try again.');
        }
    };

    const openEditAddressModal = (address) => {
        setEditingAddress(address);
        setIsAddressModalOpen(true);
    };

    const handleDeleteAddress = async (addressToDelete) => {
        try {
            await axios.delete('https://api.dailyfit.ae/api/user/delete-address', {
                data: { identifier: addressToDelete.identifier },
                withCredentials: true
            });

            setProfileData(prev => ({
                ...prev,
                savedAddress: prev.savedAddress.filter(addr =>
                    addr.identifier !== addressToDelete.identifier
                )
            }));
            toast.success('Address deleted successfully!');
        } catch (err) {
            console.error('Error deleting address', err);
            toast.error('Failed to delete address. Please try again.');
        }
    };

    const handleExtensionDateClick = (orderID) => {
        setSelectedOrderForExtension(orderID);
        setIsExtensionModalOpen(true);
    };

    const handleExtensionConfirm = async (orderID, selectedDates) => {
        try {
            const extendedDate = selectedDates[selectedDates.length - 1];
            const response = await axios.post('https://api.dailyfit.ae/api/user/extend-order', {
                orderID: orderID,
                extendedDate: extendedDate.toISOString()
            }, { withCredentials: true });

            if (response.data.success) {
                setProfileData(prev => ({
                    ...prev,
                    orders: prev.orders.map(order =>
                        order?.orderID === orderID
                            ? { ...order, extendedDate: extendedDate }
                            : order
                    )
                }));

                toast.success('Extension confirmed successfully!');
                setIsExtensionModalOpen(false);
                setSelectedOrderForExtension(null);
            }
        } catch (err) {
            console.error('Error confirming extension', err);
            toast.error('Failed to confirm extension. Please try again.');
        }
    };

    const handlePayNow = async (order) => {
        try {
            if (!order.RazorPayOrderDetails || !order.RazorPayOrderDetails.id) {
                console.error('Missing RazorPay order details');
                return;
            }

            const options = {
                key: "your_razorpay_key_id",
                amount: order.RazorPayOrderDetails.amount,
                currency: order.RazorPayOrderDetails.currency,
                name: "DailyFit",
                description: `Payment for Order ID: ${order.orderID}`,
                order_id: order.RazorPayOrderDetails.id,
                handler: function (response) {
                    verifyPayment(response, order.orderID);
                },
                prefill: {
                    name: profileData.userName,
                    email: profileData.userEmail,
                    contact: profileData.phone || ""
                },
                theme: {
                    color: "#16a34a"
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (err) {
            console.error('Error initiating payment', err);
        }
    };

    const handleRetryPayment = (order) => {
        handlePayNow(order);
    };

    const verifyPayment = async (paymentResponse, orderID) => {
        try {
            const response = await axios.post(
                'https://api.dailyfit.ae/api/user/verify-payment',
                {
                    orderID: orderID,
                    paymentID: paymentResponse.razorpay_payment_id,
                    razorpay_order_id: paymentResponse.razorpay_order_id,
                    razorpay_signature: paymentResponse.razorpay_signature
                },
                { withCredentials: true }
            );

            if (response.data.status) {
                setProfileData(prev => ({
                    ...prev,
                    orders: prev.orders.map(order =>
                        order?.orderID === orderID
                            ? { ...order, paymentStatus: 1 }
                            : order
                    )
                }));

                toast.success('Payment successful!');
            } else {
                toast.error('Payment verification failed. Please try again.');
            }
        } catch (err) {
            console.error('Payment verification error', err);
            toast.error('Payment verification failed. Please try again.');
        }
    };

    const handleLogout = async () => {
        try {
            await axios.post('https://api.dailyfit.ae/api/user/logout', {}, { withCredentials: true });
            window.location.href = '/Order';
        } catch (err) {
            console.error('Logout error', err);
        }
    };

    const getInitials = (name) => {
        if (!name) return "";
        const parts = name.trim().split(" ");
        if (parts.length === 1) return parts[0][0].toUpperCase();
        return (parts[0][0] + parts[1][0]).toUpperCase();
    };

    // Handle profile updates
    const handleProfileUpdate = (updatedData) => {
        setProfileData(prev => ({
            ...prev,
            ...updatedData
        }));
    };

    // Handle profile image updates
    const handleImageUpdate = (updatedData) => {
        setProfileData(prev => ({
            ...prev,
            profileImage: updatedData.profileImage || prev.profileImage
        }));
    };

    // Enhanced Personal Information Section with Edit Button
    const EnhancedPersonalInfo = ({ user, onEditClick }) => {
        return (
            <div className="bg-white shadow-lg rounded-xl p-6 border border-green-200">
                <div className="flex justify-between items-start mb-6">
                    <div>
                        <h2 className="text-2xl font-bold text-green-800">Personal Information</h2>
                        <p className="text-gray-600">Manage your personal details and preferences</p>
                    </div>
                    <button
                        onClick={onEditClick}
                        className="flex items-center text-green-600 hover:text-green-700 bg-green-50 hover:bg-green-100 px-4 py-2 rounded-lg transition-colors"
                    >
                        <Edit size={18} className="mr-2" />
                        Edit Profile
                    </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                        <div>
                            <label className="text-sm font-medium text-gray-500">Full Name</label>
                            <p className="text-lg text-gray-900">{user.userName}</p>
                        </div>
                        <div>
                            <label className="text-sm font-medium text-gray-500">Email</label>
                            <p className="text-lg text-gray-900">{user.userEmail}</p>
                        </div>
                        <div>
                            <label className="text-sm font-medium text-gray-500">Phone</label>
                            <p className="text-lg text-gray-900">
                                {user.phone ? `${user.countryCode || ''} ${user.phone}` : 'Not set'}
                            </p>
                        </div>
                    </div>

                    <div className="space-y-4">
                        <div>
                            <label className="text-sm font-medium text-gray-500">Date of Birth</label>
                            <p className="text-lg text-gray-900">
                                {user.dateOfBirth ? new Date(user.dateOfBirth).toLocaleDateString() : 'Not set'}
                            </p>
                        </div>
                        <div>
                            <label className="text-sm font-medium text-gray-500">Gender</label>
                            <p className="text-lg text-gray-900 capitalize">{user.gender || 'Not set'}</p>
                        </div>
                        <div>
                            <label className="text-sm font-medium text-gray-500">Bio</label>
                            <p className="text-lg text-gray-900">{user.bio || 'No bio added yet'}</p>
                        </div>
                    </div>
                </div>

                {/* Preferences Section */}
                {user.preferences && (
                    <div className="mt-8 pt-6 border-t border-gray-200">
                        <h3 className="text-xl font-semibold text-green-800 mb-4">Preferences</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <div>
                                <h4 className="font-medium text-gray-700 mb-2">Dietary Restrictions</h4>
                                <div className="flex flex-wrap gap-1">
                                    {user.preferences.dietaryRestrictions?.length > 0 ? (
                                        user.preferences.dietaryRestrictions.map(restriction => (
                                            <span key={restriction} className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-sm capitalize">
                                                {restriction.replace('-', ' ')}
                                            </span>
                                        ))
                                    ) : (
                                        <span className="text-gray-500 text-sm">None specified</span>
                                    )}
                                </div>
                            </div>

                            <div>
                                <h4 className="font-medium text-gray-700 mb-2">Allergies</h4>
                                <div className="flex flex-wrap gap-1">
                                    {user.preferences.allergies?.length > 0 ? (
                                        user.preferences.allergies.map(allergy => (
                                            <span key={allergy} className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-sm capitalize">
                                                {allergy}
                                            </span>
                                        ))
                                    ) : (
                                        <span className="text-gray-500 text-sm">None specified</span>
                                    )}
                                </div>
                            </div>

                            <div>
                                <h4 className="font-medium text-gray-700 mb-2">Fitness Goals</h4>
                                <div className="flex flex-wrap gap-1">
                                    {user.preferences.fitnessGoals?.length > 0 ? (
                                        user.preferences.fitnessGoals.map(goal => (
                                            <span key={goal} className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-sm capitalize">
                                                {goal.replace('_', ' ')}
                                            </span>
                                        ))
                                    ) : (
                                        <span className="text-gray-500 text-sm">None specified</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen bg-green-50">
                <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-green-600"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex justify-center items-center h-screen bg-green-50 text-red-600">
                <p>Error loading profile: {error.message}</p>
            </div>
        );
    }

    if (!profileData) {
        return null;
    }

    return (
        <div className="bg-gradient-to-b from-green-50 to-green-100 min-h-screen pb-12">
            <Navigation />
            <ToastContainer position="top-right" autoClose={3000} />

            <div className="container mx-auto px-4 py-8 max-w-6xl">
                <div className="flex mb-8 bg-white rounded-xl shadow-md overflow-hidden">
                    <button
                        className={`flex-1 px-6 py-4 transition-colors font-medium ${activeTab === 'profile'
                            ? 'bg-green-700 text-white shadow-inner'
                            : 'text-green-700 hover:bg-green-50'
                            }`}
                        onClick={() => setActiveTab('profile')}
                    >
                        <div className="flex items-center justify-center">
                            <UserCircle className="h-5 w-5 mr-2" />
                            Profile & Addresses
                        </div>
                    </button>
                    <button
                        className={`flex-1 px-6 py-4 transition-colors font-medium ${activeTab === 'orders'
                            ? 'bg-green-700 text-white shadow-inner'
                            : 'text-green-700 hover:bg-green-50'
                            }`}
                        onClick={() => setActiveTab('orders')}
                    >
                        <div className="flex items-center justify-center">
                            <ShoppingBag className="h-5 w-5 mr-2" />
                            My Orders
                        </div>
                    </button>
                </div>

                {activeTab === 'profile' && (
                    <div className="space-y-8">
                        {/* Enhanced Profile Header with Image Upload */}
                        <div className="bg-white shadow-xl rounded-2xl overflow-hidden border border-gray-100">
                            <div className="bg-gradient-to-r from-green-500 to-green-900 p-8 text-white">
                                <div className="flex flex-col lg:flex-row items-center justify-between space-y-6 lg:space-y-0">
                                    <div className="flex flex-col lg:flex-row items-center space-y-4 lg:space-y-0 lg:space-x-6">
                                        <ProfileImageUpload 
                                            userData={profileData} 
                                            onImageUpdate={handleImageUpdate}
                                        />
                                        <div className="text-center lg:text-left">
                                            <h1 className="text-3xl font-bold">{profileData.userName}</h1>
                                            <p className="text-green-100 opacity-90">{profileData.userEmail}</p>
                                            <p className="text-green-200 text-sm mt-2">
                                                Member since {new Date(profileData.createdAt).toLocaleDateString()}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex space-x-3">
                                        <button
                                            onClick={() => setIsProfileEditModalOpen(true)}
                                            className="bg-white text-green-700 px-4 py-2 rounded-lg font-semibold hover:bg-green-50 transition-colors flex items-center"
                                        >
                                            <Edit size={18} className="mr-2" />
                                            Edit Profile
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Personal Information Card */}
                        <EnhancedPersonalInfo 
                            user={profileData} 
                            onEditClick={() => setIsProfileEditModalOpen(true)}
                        />

                        {/* Address Section */}
                        <div className="bg-white shadow-lg rounded-xl p-8 border-l-4 border-green-600 hover:shadow-xl transition-shadow duration-300">
                            <div className="flex justify-between items-center mb-6">
                                <div className="flex items-center">
                                    <div className="bg-green-100 p-3 rounded-full mr-4 border border-green-200">
                                        <Home className="h-6 w-6 text-green-600" />
                                    </div>
                                    <h2 className="text-2xl font-bold text-green-800">Saved Addresses</h2>
                                </div>
                                <button
                                    onClick={() => {
                                        setEditingAddress(null);
                                        setIsAddressModalOpen(true);
                                    }}
                                    className="flex items-center text-white bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg transition-colors shadow-md"
                                >
                                    <Plus className="h-5 w-5 mr-2" />
                                    Add New Address
                                </button>
                            </div>

                            <div className="grid md:grid-cols-2 gap-6">
                                {profileData.savedAddress?.map((address, index) => (
                                    <div
                                        key={index}
                                        className="border border-green-200 rounded-lg p-4 flex justify-between items-center hover:bg-green-50 transition"
                                    >
                                        <div>
                                            <p className="font-semibold text-green-900">{address.streetName}</p>
                                            <p className="text-gray-600">{address.buildingFloor}, {address.houseOrFlatNumber}</p>
                                            <p className="text-gray-600">{address.landmark}</p>
                                            <p className="text-gray-600">
                                                {address.city}, {address.state} {address.postalCode}
                                            </p>
                                            <p className="text-gray-600">{address.country}</p>
                                            <p className="text-gray-600">Phone: {address.phone}</p>
                                        </div>
                                        <div className="flex space-x-2">
                                            <button
                                                onClick={() => openEditAddressModal(address)}
                                                className="text-green-600 hover:bg-green-100 p-2 rounded"
                                            >
                                                <Edit size={20} />
                                            </button>
                                            <button
                                                onClick={() => handleDeleteAddress(address)}
                                                className="text-red-600 hover:bg-red-100 p-2 rounded"
                                            >
                                                <Trash2 size={20} />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'orders' && (
                    <div className="bg-white shadow-lg rounded-xl p-8 border-l-4 border-green-600 hover:shadow-xl transition-shadow duration-300">
                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
                            <div className="flex items-center">
                                <div className="bg-green-100 p-3 rounded-full mr-4 border border-green-200">
                                    <ShoppingBag className="h-6 w-6 text-green-600" />
                                </div>
                                <h2 className="text-2xl font-bold text-green-800">My Orders</h2>
                            </div>

                            <div className="relative">
                                <select
                                    className="appearance-none bg-green-50 border border-green-300 text-green-700 py-2 px-4 pr-8 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent cursor-pointer font-medium"
                                    onChange={(e) => setPaymentStatusFilter(parseInt(e.target.value))}
                                    value={paymentStatusFilter}
                                >
                                    <option value="-1">All Orders</option>
                                    <option value="0">Payment Pending</option>
                                    <option value="1">Payment Successful</option>
                                    <option value="2">Payment Failed</option>
                                </select>
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-green-700">
                                    <ChevronDown className="h-4 w-4" />
                                </div>
                            </div>
                        </div>

                        {loading ? (
                            <div className="text-center py-12">
                                <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-600"></div>
                                <p className="mt-4 text-green-700 font-medium">Loading your orders...</p>
                            </div>
                        ) : error ? (
                            <div className="bg-red-100 p-4 rounded-lg text-center border border-red-200">
                                <div className="bg-white p-4 inline-block rounded-full mb-4">
                                    <X className="h-10 w-10 text-red-500 mx-auto" />
                                </div>
                                <p className="text-red-700 font-medium">Something went wrong while loading your orders.</p>
                                <button className="mt-3 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors">
                                    Try Again
                                </button>
                            </div>
                        ) : profileData?.orders?.length > 0 ? (
                            <div className="space-y-6">
                                {profileData.orders
                                    .filter(order => paymentStatusFilter === -1 || order.paymentStatus === paymentStatusFilter)
                                    .map((order, index) => (
                                        <div key={index} className="border border-green-200 rounded-xl overflow-hidden hover:shadow-lg transition duration-300">
                                            <div
                                                className={`p-4 sm:p-6 ${expandedOrderId === order.orderID ? 'bg-green-50' : 'bg-white'} hover:bg-green-50 cursor-pointer transition-colors`}
                                                onClick={() => handleExpandOrder(order)}
                                            >
                                                <div className="flex flex-col gap-4">
                                                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                                                        <div className="flex flex-wrap items-center gap-2 sm:gap-4">
                                                            <div className="flex items-center">
                                                                <div className="bg-green-700 text-white rounded-l-lg px-2 py-1 sm:px-3 sm:py-2">
                                                                    <ShoppingBag className="h-4 w-4 sm:h-5 sm:w-5" />
                                                                </div>
                                                                <div className="flex items-center gap-2">
                                                                    <div className="bg-green-100 text-green-800 rounded-r-lg px-2 py-1 text-xs font-medium">
                                                                        {order.orderID}
                                                                    </div>
                                                                    <span className="inline-block bg-green-700 text-white px-3 py-1 rounded-lg text-xs sm:text-sm font-medium">{order?.selectedMeals?.package?.plan?.mealPlanName}</span>
                                                                </div>
                                                            </div>
                                                            <span className="text-sm font-medium text-green-800">
                                                                {order.selectedPackage?.packageName || "Package"}
                                                            </span>
                                                        </div>

                                                        <div className="flex items-center self-start sm:self-auto">
                                                            <div className="bg-green-700 text-white px-2 py-1 sm:px-3 sm:py-2 rounded-l-lg text-xs sm:text-sm font-medium">
                                                                TOTAL
                                                            </div>
                                                            <div className="bg-green-600 text-white px-2 py-1 sm:px-3 sm:py-2 text-xs sm:text-sm font-bold">
                                                                AED
                                                            </div>
                                                            <div className="bg-green-100 text-green-800 px-2 py-1 sm:px-3 sm:py-2 rounded-r-lg text-xs sm:text-lg font-bold">
                                                                {order.amount}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="flex flex-col sm:flex-row justify-between gap-4">
                                                        <div className="flex flex-wrap gap-2 sm:gap-6">
                                                            <div className="flex items-center bg-green-50 px-2 py-1 sm:px-3 sm:py-2 rounded-lg border border-green-200">
                                                                <Calendar className="h-4 w-4 sm:h-5 sm:w-5 mr-1 sm:mr-2 text-green-600" />
                                                                <div>
                                                                    <span className="block text-xs text-green-600">Start</span>
                                                                    <span className="text-xs sm:text-sm font-medium text-green-800">{order.startDate?.slice(0, 10) || order.selectedPackage?.startDate}</span>
                                                                </div>
                                                            </div>
                                                            <div className="flex items-center bg-green-50 px-2 py-1 sm:px-3 sm:py-2 rounded-lg border border-green-200">
                                                                <Calendar className="h-4 w-4 sm:h-5 sm:w-5 mr-1 sm:mr-2 text-green-600" />
                                                                <div>
                                                                    <span className="block text-xs text-green-600">End</span>
                                                                    <span className="text-xs sm:text-sm font-medium text-green-800">{order.endDate?.slice(0, 10) || order.selectedPackage?.endDate}</span>
                                                                </div>
                                                            </div>
                                                            <div className={`flex items-center px-2 py-1 sm:px-3 sm:py-2 rounded-lg border 
                                                                ${order.paymentStatus === 1 
                                                                    ? 'bg-green-50 border-green-200 cursor-pointer hover:bg-green-100 transition-colors' 
                                                                    : 'bg-gray-100 border-gray-200 cursor-not-allowed opacity-70'}`}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    // Only allow extension if payment is successful
                                                                    if (order.paymentStatus === 1) {
                                                                        handleExtensionDateClick(order.orderID);
                                                                    }
                                                                }}
                                                                title={order.paymentStatus !== 1 ? "Complete your payment first to extend your meal plan" : "Extend your meal plan"}>
                                                                <Calendar className="h-4 w-4 sm:h-5 sm:w-5 mr-1 sm:mr-2 text-green-600" />
                                                                <div>
                                                                    <span className="block text-xs text-green-600">Extend Date</span>
                                                                    <span className="text-xs sm:text-sm font-medium text-green-800">
                                                                        {order.extendedDate?.slice(0, 10) || 
                                                                            (order.paymentStatus === 1 ? 'Click to extend' : 'Complete payment first')}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <div>
                                                                <div className="flex items-center">
                                                                    {order.bagIncluded ? (
                                                                        <>
                                                                            <div className="h-4 w-4 sm:h-5 sm:w-5 text-green-600 mr-1 bg-green-100 rounded-full flex items-center justify-center">
                                                                                <div className="h-2 w-2 bg-green-600 rounded-full"></div>
                                                                            </div>
                                                                            <span className="text-xs sm:text-sm font-medium text-green-600">Bag Included</span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <div className="h-4 w-4 sm:h-5 sm:w-5 text-gray-400 mr-1 bg-gray-100 rounded-full flex items-center justify-center">
                                                                                <X className="h-3 w-3" />
                                                                            </div>
                                                                            <span className="text-xs sm:text-sm font-medium text-gray-500">Bag Not Included</span>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="flex flex-wrap items-center justify-between gap-2 sm:gap-3 mt-2 sm:mt-0">
                                                        <div className="flex flex-wrap items-center gap-2">
                                                            {order.paymentStatus === 0 && (
                                                                <span className="bg-yellow-100 text-yellow-800 px-2 py-1 sm:px-3 sm:py-2 rounded-lg text-xs sm:text-sm font-medium flex items-center border border-yellow-200">
                                                                    <div className="h-3 w-3 bg-yellow-500 rounded-full mr-2"></div>
                                                                    Payment Pending
                                                                </span>
                                                            )}
                                                            {order.paymentStatus === 1 && (
                                                                <span className="bg-green-100 text-green-800 px-2 py-1 sm:px-3 sm:py-2 rounded-lg text-xs sm:text-sm font-medium inline-flex items-center border border-green-200">
                                                                    <div className="h-3 w-3 bg-green-500 rounded-full mr-2"></div>
                                                                    Payment Successful
                                                                </span>
                                                            )}
                                                            {order.paymentStatus === 2 && (
                                                                <span className="bg-red-100 text-red-800 px-2 py-1 sm:px-3 sm:py-2 rounded-lg text-xs sm:text-sm font-medium inline-flex items-center border border-red-200">
                                                                    <div className="h-3 w-3 bg-red-500 rounded-full mr-2"></div>
                                                                    Payment Failed
                                                                </span>
                                                            )}
                                                        </div>

                                                        <div className="flex flex-wrap items-center gap-2">
                                                            {order.paymentStatus === 0 && (
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handlePayNow(order);
                                                                    }}
                                                                    className="bg-green-600 hover:bg-green-700 text-white text-xs sm:text-sm font-medium px-3 py-1 sm:px-4 sm:py-2 rounded-lg transition shadow-md flex items-center"
                                                                >
                                                                    <div className="h-4 w-4 sm:h-5 sm:w-5 mr-1 bg-white text-green-600 rounded-full flex items-center justify-center">
                                                                        <div className="h-2 w-2 bg-green-600 rounded-full"></div>
                                                                    </div>
                                                                    Pay Now
                                                                </button>
                                                            )}
                                                            {order.paymentStatus === 2 && (
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleRetryPayment(order);
                                                                    }}
                                                                    className="bg-green-600 hover:bg-green-700 text-white text-xs sm:text-sm font-medium px-3 py-1 sm:px-4 sm:py-2 rounded-lg transition shadow-md flex items-center"
                                                                >
                                                                    <div className="h-4 w-4 sm:h-5 sm:w-5 mr-1 bg-white text-green-600 rounded-full flex items-center justify-center">
                                                                        <div className="h-2 w-2 bg-green-600 rounded-full"></div>
                                                                    </div>
                                                                    Retry Payment
                                                                </button>
                                                            )}

                                                            <div className="ml-auto sm:ml-2">
                                                                {expandedOrderId === order.orderID ? (
                                                                    <div className="bg-green-200 p-1 sm:p-2 rounded-full transition-transform duration-300 transform rotate-180 border border-green-300">
                                                                        <ChevronDown className="h-5 w-5 sm:h-6 sm:w-6 text-green-700" />
                                                                    </div>
                                                                ) : (
                                                                    <div className="bg-green-200 p-1 sm:p-2 rounded-full transition-transform duration-300 border border-green-300">
                                                                        <ChevronDown className="h-5 w-5 sm:h-6 sm:w-6 text-green-700" />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Table View for Package Details */}
                                            {expandedOrderId === order.orderID && packageDetails[order?.orderID] && (
                                                <div className="p-4 bg-white border-t border-green-200">
                                                    <div className="mb-6">
                                                        <h3 className="text-lg font-semibold text-green-800 mb-4">Meal Details</h3>
                                                        
                                                        {packageDetails[order?.orderID]?.data[0]?.selectedMeals
                                                            ?.slice() // Create a copy of the array to avoid mutating the original
                                                            .sort((a, b) => new Date(a.date) - new Date(b.date)) // Sort by date
                                                            .map((dayMeal, index) => (
                                                            <div key={index} className="mb-8">
                                                                <h4 className="text-md font-medium text-green-700 mb-3 bg-green-50 p-3 rounded-lg">
                                                                    Meals for {new Date(dayMeal.date).toLocaleDateString('en-US', {
                                                                        weekday: 'long',
                                                                        month: 'long',
                                                                        day: 'numeric'
                                                                    })}
                                                                </h4>
                                                                
                                                                <div className="overflow-x-auto">
                                                                    <table className="min-w-full bg-white border border-green-200 rounded-lg">
                                                                        <thead className="bg-green-600 text-white">
                                                                            <tr>
                                                                                <th className="py-3 px-4 text-left" rowSpan="2">Meal</th>
                                                                                <th className="py-3 px-4 text-left" rowSpan="2">Type</th>
                                                                                <th className="py-3 px-4 text-center" colSpan="2">Portion Details</th>
                                                                                <th className="py-3 px-4 text-center" rowSpan="2">Calories</th>
                                                                                <th className="py-3 px-4 text-center" colSpan="3">Nutrition per Portion</th>
                                                                                <th className="py-3 px-4 text-left" rowSpan="2">Allergens</th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th className="py-3 px-2 text-center text-sm">Portion</th>
                                                                                <th className="py-3 px-2 text-center text-sm">Weight</th>
                                                                                <th className="py-3 px-2 text-center text-sm">Protein (g)</th>
                                                                                <th className="py-3 px-2 text-center text-sm">Carbs (g)</th>
                                                                                <th className="py-3 px-2 text-center text-sm">Fat (g)</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {dayMeal.meals.map((meal, idx) => (
                                                                                <tr key={idx} className={idx % 2 === 0 ? 'bg-green-50' : 'bg-white'}>
                                                                                    <td className="py-3 px-4 border-b border-green-200">
                                                                                        <div className="flex items-center">
                                                                                            {meal.image?.[0] && (
                                                                                                <img 
                                                                                                    src={meal.image[0]} 
                                                                                                    alt={meal.mealName} 
                                                                                                    className="h-10 w-10 object-cover rounded mr-3"
                                                                                                />
                                                                                            )}
                                                                                            <div>
                                                                                                <div className="font-medium text-green-900">{meal.mealName}</div>
                                                                                                <div className="text-sm text-gray-600 line-clamp-1">{meal.description}</div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="py-3 px-4 border-b border-green-200">
                                                                                        {meal.mealType?.[0]?.mealType && (
                                                                                            <span className="bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded">
                                                                                                {meal.mealType[0].mealType}
                                                                                            </span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="py-3 px-4 border-b border-green-200 text-center">
                                                                                        {meal.portionDetails?.portion || 'N/A'}
                                                                                    </td>
                                                                                    <td className="py-3 px-4 border-b border-green-200 text-center">
                                                                                        {meal.portionDetails?.weight || 'N/A'}
                                                                                    </td>
                                                                                    <td className="py-3 px-4 border-b border-green-200 text-center font-medium">
                                                                                        {meal.moreDetails.energy} kcal
                                                                                    </td>
                                                                                    <td className="py-3 px-4 border-b border-green-200 text-center font-medium">
                                                                                        {meal.moreDetails.protein}g
                                                                                    </td>
                                                                                    <td className="py-3 px-4 border-b border-green-200 text-center font-medium">
                                                                                        {meal.moreDetails.carbohydrates}g
                                                                                    </td>
                                                                                    <td className="py-3 px-4 border-b border-green-200 text-center font-medium">
                                                                                        {meal.moreDetails.fat}g
                                                                                    </td>
                                                                                    <td className="py-3 px-4 border-b border-green-200">
                                                                                        {meal.moreDetails.allergens?.length > 0 ? (
                                                                                            <span className="text-red-600 text-sm">
                                                                                                {meal.moreDetails.allergens.join(', ')}
                                                                                            </span>
                                                                                        ) : (
                                                                                            <span className="text-green-600 text-sm">None</span>
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {packageDetails[order?.orderID]?.data[0]?.addons?.length > 0 && (
                                                        <div>
                                                            <h3 className="text-lg font-semibold text-green-800 mb-4">Addon Products</h3>
                                                            <div className="overflow-x-auto">
                                                                <table className="min-w-full bg-white border border-green-200 rounded-lg">
                                                                    <thead className="bg-purple-600 text-white">
                                                                        <tr>
                                                                            <th className="py-3 px-4 text-left">Product</th>
                                                                            <th className="py-3 px-4 text-left">Description</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {packageDetails[order?.orderID]?.data[0]?.addons?.map((addon, idx) => (
                                                                            <tr key={idx} className={idx % 2 === 0 ? 'bg-purple-50' : 'bg-white'}>
                                                                                <td className="py-3 px-4 border-b border-purple-200">
                                                                                    <div className="flex items-center">
                                                                                        {addon.image?.[0] && addon.image[0] !== "" ? (
                                                                                            <img 
                                                                                                src={addon.image[0]} 
                                                                                                alt={addon.mealName} 
                                                                                                className="h-10 w-10 object-cover rounded mr-3"
                                                                                            />
                                                                                        ) : (
                                                                                            <div className="h-10 w-10 bg-purple-100 rounded mr-3 flex items-center justify-center text-purple-400">
                                                                                                📷
                                                                                            </div>
                                                                                        )}
                                                                                        <div className="font-medium text-purple-900">{addon.mealName}</div>
                                                                                    </div>
                                                                                </td>
                                                                                <td className="py-3 px-4 border-b border-purple-200 text-sm text-gray-600">
                                                                                    {addon.description}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                            </div>
                        ) : (
                            <div className="text-center py-12 bg-green-50 rounded-xl border border-green-200">
                                <div className="bg-white p-4 inline-block rounded-full mb-4 border border-green-200">
                                    <ShoppingBag className="h-12 w-12 text-green-500" />
                                </div>
                                <h3 className="text-xl font-semibold text-green-800 mb-2">No Orders Yet</h3>
                                <p className="text-gray-600 mb-6">You haven't placed any orders yet. Start exploring our meal packages!</p>
                                <button className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg transition-colors shadow-md font-medium flex items-center justify-center mx-auto">
                                    <ShoppingBag className="h-5 w-5 mr-2" />
                                    Browse Packages
                                </button>
                            </div>
                        )}
                    </div>
                )}

                <AddressModal
                    isOpen={isAddressModalOpen}
                    onClose={() => setIsAddressModalOpen(false)}
                    onSubmit={async (address) => {
                        if (editingAddress) {
                            await handleEditAddress(address);
                        } else {
                            await handleAddAddress(address);
                        }
                    }}
                    initialAddress={editingAddress}
                />

                <ExtensionModal
                    isOpen={isExtensionModalOpen}
                    onClose={() => {
                        setIsExtensionModalOpen(false);
                        setSelectedOrderForExtension(null);
                    }}
                    orderID={selectedOrderForExtension}
                    onExtensionConfirm={handleExtensionConfirm}
                />

                <ProfileEditModal
                    isOpen={isProfileEditModalOpen}
                    onClose={() => setIsProfileEditModalOpen(false)}
                    userData={profileData}
                    onProfileUpdate={handleProfileUpdate}
                />
            </div>
        </div>
    );
};

export default UserProfile;